import React, {useEffect, useRef, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {includeInsuranceBalanceNoteUpdate} from '../actions';
import {showOtherInputFieldsTrue, showOtherInputFieldsFalse} from '../actions';
import {showBillingAddressDropTrue, showBillingAddressDropFalse} from '../actions';
import {showBillingAddressFieldsTrue, showBillingAddressFieldsFalse} from '../actions';
import {css_insAdd, css_insRemove} from '../actions';
import {message6DisplayPropertyDisplay, message6DisplayPropertyHide} from '../actions';
import {message8DisplayPropertyDisplay, message8DisplayPropertyHide} from '../actions';
import {payRemainingBalanceValue} from '../actions';
import {minimumPaymentAmountValue} from '../actions';
import {bookingDueTodayAnswer} from '../actions';
import {paymentOptionFull, paymentOptionOther, paymentOptionClear} from '../actions';
import {paymentAmountUpdater} from '../actions';
import {totalcostset} from '../actions';
import {paidInFullLanguageUpdater} from '../actions';
import {insuranceStatusIncluded, insuranceStatusNotIncluded, insuranceStatusPaymentRequired} from '../actions';
import {insuranceVendorLeisure, insuranceVendorOther} from '../actions';
import {remainingBalanceNegativeTrue} from '../actions';
import {bookingPastDueTrue} from '../actions';
import {balanceDueTrue} from '../actions';
import {remainingBalanceSet} from '../actions';
import {remainingBalanceAsFloatSet} from '../actions';
import {paymentDueSet} from '../actions';
import {paymentOtherUpdate} from '../actions';
import {paymentOtherActiveTrue, paymentOtherActiveFalse} from '../actions';
import {scheduledPaymentHasChangedTrue} from '../actions';
import {confirmViewUpdate} from '../actions';
import {ccBillingAddressForVerificationUpdate} from '../actions';
import {cssAddress1Update, cssAddress2Update} from '../actions';
import {cssCityUpdate} from '../actions';
import {cssPaymentStateUpdate} from '../actions';
import {cssZipUpdate} from '../actions';
import {ccMonthUpdate} from '../actions';
import {ccYearUpdate} from '../actions';
import {confirmViewFuturePaymentsUpdate} from '../actions';
import {confirmViewRemainingBalanceUpdate} from '../actions';
import {ccHolderForVerificationNameUpdate} from '../actions';
import {balancePayRemainingValue} from '../actions';
import Popup from 'reactjs-popup';
import {DateTime} from 'luxon';
import NumberFormat from 'react-number-format';
import {noCase} from "change-case";
import InputFieldValue from '../inputContainer/InputFieldValue';
import InputFieldLabel from '../inputContainer/InputFieldLabel';
import './paymentDetails.css';
import SvgCheckmark from '../svg/svgCheckmark';
import SummaryChargesDesktop from '../summary-charges-details/SummaryChargesDesktop';
import SummaryChargesMobile from '../summary-charges-details/SummaryChargesMobile';
import { useEffectMobileSummaryCharges } from '../useEffect/useEffectMobileSummaryCharges';


function getFormattedDate(dateToFormat) {
	let formattedDate = DateTime.fromISO(dateToFormat).toLocaleString(DateTime.DATE_FULL);
	return formattedDate;
}

function isPastDue(checkDate){
	let currentDate = DateTime.now();
	let dueDateasDate=DateTime.fromISO(checkDate);
	if(dueDateasDate<currentDate){
		return true;
	}
	else{return false;}
}
function isDueToday(checkToday){
	let currentDate = Date.now();
	let dueDateasDate2=new Date(checkToday);
	if(dueDateasDate2!==currentDate){
		return false;
	}
	else{return true;}
}

/* Spinner for Ajax calls */
function ajaxSpinnerShow() {
	 document.getElementById("ajaxLoadText").innerHTML = "loading";
	 document.getElementById("ajaxShim").style.display = "block";
	 document.getElementById("ajaxSpinnerOuter").style.display = "block";
	 document.getElementById("ajaxSpinner").style.display = "block";
 }	
 
 function ajaxSpinnerHide() {
	 document.getElementById("ajaxSpinner").style.display = "none";
	 document.getElementById("ajaxSpinnerOuter").style.display = "none";
	 document.getElementById("ajaxShim").style.display = "none";
 }

function PaymentDetails(props) {   
     
     
     //initial sets
	const showOtherInputFields = useSelector(state => state.showOtherInputFields);
    const showBillingAddressDrop = useSelector(state => state.showBillingAddressDrop);
    const showBillingAddressFields = useSelector(state => state.showBillingAddressFields);
    const css_ins = useSelector(state => state.css_ins);
    const message6DisplayProperty = useSelector(state => state.message6DisplayProperty);
    const insuranceStatus = useSelector(state => state.insuranceStatus);
    const insuranceVendor = useSelector(state => state.insuranceVendor);
    const remainingBalanceNegative = useSelector(state => state.remainingBalanceNegative);
    const bookingPastDue = useSelector(state => state.bookingPastDue);
    const balanceDue = useSelector(state => state.balanceDue);
    const remainingBalance = useSelector(state => state.remainingBalance);
    const paymentDue = useSelector(state => state.paymentDue);
    const payRemainingBalance = useSelector(state => state.payRemainingBalance);
    const minimumPaymentAmount = useSelector(state => state.minimumPaymentAmount);
    const paymentOption = useSelector(state => state.paymentOption);
    const paymentAmount = useSelector(state => state.paymentAmount);
    const paidInFullLanguage = useSelector(state => state.paidInFullLanguage);
    const totalcost = useSelector(state => state.totalcost);
    const insuranceBalanceNote = useSelector(state => state.insuranceBalanceNote);
    const paymentOther = useSelector(state => state.paymentOther);
    const message8DisplayProperty = useSelector(state => state.message8DisplayProperty);
    const scheduledPaymentHasChanged = useSelector(state => state.scheduledPaymentHasChanged);
    const ccBillingAddressForVerification = useSelector(state => state.ccBillingAddressForVerification);
    const css_address1 = useSelector(state => state.css_address1);
    const css_address2 = useSelector(state => state.css_address2);
    const css_city = useSelector(state => state.css_city);
    const css_paymentState = useSelector(state => state.css_paymentState);
    const css_zip = useSelector(state => state.css_zip);
    const ccMonth = useSelector(state => state.ccMonth);
    const ccYear = useSelector(state => state.ccYear);
    const confirmViewFuturePayments = useSelector(state => state.confirmViewFuturePayments);
    const confirmViewRemainingBalance = useSelector(state => state.confirmViewRemainingBalance);
    const ccHolderForVerificationName = useSelector(state => state.ccHolderForVerificationName);
	const inputRefs = useRef({});
	const [travelInsurance, setTravelInsurance] = useState(null);
	const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);

	// credit card holder
	const [isOpenCCHolder, setIsOpenCCHolder] = useState(false);
	const [selectedOptionCCName, setSelectedOptionCCName] = useState({});
	const refCCHolderList = useRef(null);
	const refCCHOlderContainer = useRef(null);
	const [highlighedIndexCCHolder, setHighlighedIndexCCHolder] = useState(-1);
	const [selectedIndexCCHolder, setSelectedIndexCCHolder] = useState(-1)
	
	// billing address
	const [selectedOptionBillingAddress, setSelectedOptionBillingAddress] = useState({});
	const [billingAddress, setBillingAddress] = useState([]);
	const [defaultBillingText, setDefaultBillingText] = useState('Choose billing address');
	const [isOpenBillingAddress, setIsOpenBillingAddress] = useState(false);
	const billingListRef = useRef(null);
	const [highlighedIndexBillAddress, setHighlighedIndexBillAddress] = useState(-1);
	const [selectedIndexBillAddress, setSelectedIndexBillAddress] = useState(-1)
	const refBillAddressContainer = useRef(null)
	
	// states
	const [selectedOptionStatesName, setSelectedOptionStatesName] = useState('');
	const [statesArray, setStatesArray] = useState([]);
	const [isOpenStates, setIsOpenStates] = useState(false);
	const statesListRef = useRef(null);
	const [highlighedIndexStates, setHighlighedIndexStates] = useState(-1);
	const refStatesContainer = useRef(null)
	const [selectedIndexState, setSelectedIndexState] = useState(-1)

	// exp month
	const expMonthArray = ['MM', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	const [isOpenExpMonth, setIsOpenExpMonth] = useState(false);
	const [selectedOptionExpMonth, setSelectedOptionExpMonth] = useState('');
	const expMonthListRef = useRef(null);
	const refExpMonthContainer = useRef(null);
	const [highlighedIndexExpMonth, setHighlighedIndexExpMonth] = useState(-1);
	const [selectedIndexExpMonth, setSelectedIndexExpMonth] = useState(-1)
	
	// exp year
	const [isOpenExpYear, setIsOpenExpYear] = useState(false);
	const [selectedOptionExpYear, setSelectedOptionExpYear] = useState('');
	const expYearListRef = useRef(null);
	const refExpYearContainer = useRef(null);
	const [highlighedIndexExpYear, setHighlighedIndexExpYear] = useState(-1);
	const [selectedIndexExpYear, setSelectedIndexExpYear] = useState(-1)
	const [expYearArray, setExpYearArray] = useState(['YYYY']);

	// zip
	const [zipInputValue, setZipInputValue] = useState('');
	// city
	const [cityInputValue, setCityInputValue] = useState('');
	const [address1InputValue, setAddress1InputValue] = useState('');
	const [address2InputValue, setAddress2InputValue] = useState('');

	const [search, setSearch] = useState('')

	// dropdown list container el
	const ccHolderContainerEl = document.querySelector('#css_ccHolderContainer');
	const billAddressContainerEl = document.querySelector('#css_BillingAddressDrop');
	const statesContainerEl = document.querySelector('#css_stateContainer');
	const expMonthContainerEl = document.querySelector('#css_ccExpMonthContainer');
	const expYearContainerEl = document.querySelector('#css_ccExpYearContainer');

	const [paymentErrors, setPaymentErrors] = useState({
		"isInsuranceChoice": false,
		"isPaymentChoice": false,
		"isPaymentAmount": false,
		"isBillingAddress": false,
		"isAddress1": false,
		"isAddress2": false,
		"isCity": false,
		"isState": false,
		"isZip": false,
		"isCreditCardHolder": false,
		"isCcNumber": false,
		"isCvv": false,
		"isCCExpMonth": false,
		"isCCExpYear": false,
	});

	const [ccHolderUpdatedListLength, setCCHolderUpdatedListLength] = useState([]);

	const [message8HelpVal, setMessage8HelpVal] = useState('Travel insurance will be added to your booking once the LeisureCare plan cost is paid in full. Please make a minimum payment to continue');

	const charges = {
		pageId: 'payment',
		payRemainingBalance: payRemainingBalance,
		totalcost: totalcost,
		insuranceStatus: insuranceStatus,
		insuranceHasVendor: props.updateBooking.bookingSummary.charges.insurance.hasOwnProperty('vendor') && props.updateBooking.bookingSummary.charges.insurance.vendor.name.indexOf('BERKELY') === -1,
		insuranceVendor: insuranceVendor,
		paymentToDate: props.updateBooking.bookingSummary.charges.paymentsToDate,
		remainingBalanceNegative: remainingBalanceNegative,
		chargesRemainingBalance: props.updateBooking.bookingSummary.charges.remainingBalance,
		remainingBalance: remainingBalance,
		makePaymentRemainingBalance: props.updateBooking.makePayment.remainingBalance,
		paidInFullLanguage: paidInFullLanguage,
		balanceDue: balanceDue,
		bookingPastDue: bookingPastDue,
		cruiseLineName: props.updateBooking.bookingOverview.cruise.cruiseLineName,
		paymentDue: paymentDue,
		chargesPaymentDueDate: props.updateBooking.bookingSummary.charges.paymentDueDate,
		futurePayments: props.updateBooking.futurePayments,
		scheduledPayment: props.updateBooking.bookingSummary.charges.scheduledPayment,
		futurePaymentsRemoved: props.updateBooking.makePayment.paymentOptions.futurePaymentsRemoved,
		cruisePhone: props.siteConfigData.cruisePhone,

	}

	const handleInputChange = (e) => {
		const inputId = e.target.id;

		if (inputId === 'css_city') {
			setCityInputValue(e.target.value);
		} else if (inputId === 'css_zip') {
			setZipInputValue(e.target.value);
		} else if (inputId === 'css_address1') {
			setAddress1InputValue(e.target.value);
		} else if (inputId === 'css_address2') {
			setAddress2InputValue(e.target.value);
		}
	}

	const toggleDropdown = (e, containerID) => {
		setSearch('');

		if (containerID === 'css_BillingAddressDrop') {
			setIsOpenBillingAddress((prev) => {
				return !prev;
			})

			if (!isOpenBillingAddress) {
				const newHighlightedIndex = selectedIndexBillAddress >= 0 ? selectedIndexBillAddress : 0;
				setHighlighedIndexBillAddress(newHighlightedIndex);
				setTimeout(() => {
					if (billingListRef.current) billingListRef.current.focus();

					const highlightedLi = billingListRef.current.querySelectorAll("li")[newHighlightedIndex];
					if (highlightedLi) {
						highlightedLi.scrollIntoView({
							block: 'nearest',
						})
					}
				}, 0);
			} else {
				setHighlighedIndexBillAddress(-1);
			}

		} else if (containerID === 'css_ccHolderContainer') {
			setIsOpenCCHolder((prev) => {
				return !prev;
			})
			if (!isOpenCCHolder) {
				const newHighlightedIndex = selectedIndexCCHolder >= 0 ? selectedIndexCCHolder : 0;
				setHighlighedIndexCCHolder(newHighlightedIndex);
				setTimeout(() => {
					if (refCCHolderList.current) refCCHolderList.current.focus();

					const highlightedLi = refCCHolderList.current.querySelectorAll("li")[newHighlightedIndex];
					if (highlightedLi) {
						highlightedLi.scrollIntoView({
							block: 'nearest',
						})
					}
				}, 0);
			} else {
				setHighlighedIndexCCHolder(-1);
			}

		} else if (containerID === 'css_stateContainer') {
			setIsOpenStates((prev) => {
				return !prev;
			})
			
			if (!isOpenStates) {
				const newHighlightedIndex = selectedIndexState >= 0 ? selectedIndexState : 0;
				setHighlighedIndexStates(newHighlightedIndex);
				setTimeout(() => {
					if (statesListRef.current) statesListRef.current.focus();

					const highlightedLi = statesListRef.current.querySelectorAll("li")[newHighlightedIndex];
					if (highlightedLi) {
						highlightedLi.scrollIntoView({
							block: 'nearest',
						})
					}
				}, 0);
			} else {
				setHighlighedIndexStates(-1);
			}
		} else if (containerID === 'css_ccExpMonthContainer') {
			setIsOpenExpMonth((prev) => {
				return !prev;
			})
			
			if (!isOpenExpMonth) {
				const newHighlightedIndex = selectedIndexExpMonth >= 0 ? selectedIndexExpMonth : 0;
				setHighlighedIndexExpMonth(newHighlightedIndex);
				setTimeout(() => {
					if (expMonthListRef.current) expMonthListRef.current.focus();

					const highlightedLi = expMonthListRef.current.querySelectorAll("li")[newHighlightedIndex];
					if (highlightedLi) {
						highlightedLi.scrollIntoView({
							block: 'nearest',
						})
					}
				}, 0);
			} else {
				setHighlighedIndexExpMonth(-1);
			}
		} else if (containerID === 'css_ccExpYearContainer') {
			setIsOpenExpYear((prev) => {
				return !prev;
			})
			
			if (!isOpenExpYear) {
				const newHighlightedIndex = selectedIndexExpYear >= 0 ? selectedIndexExpYear : 0;
				setHighlighedIndexExpYear(newHighlightedIndex);
				setTimeout(() => {
					if (expYearListRef.current) expYearListRef.current.focus();

					const highlightedLi = expYearListRef.current.querySelectorAll("li")[newHighlightedIndex];
					if (highlightedLi) {
						highlightedLi.scrollIntoView({
							block: 'nearest',
						})
					}
				}, 0);
			} else {
				setHighlighedIndexExpYear(-1);
			}
		}
	}

	const handleDropdownKeyDown = (e) => {
		const selectedUlEl = e.target.id;

		if (selectedUlEl === 'customerNumberList') {
			if (!isOpenCCHolder) return;
		} else if (selectedUlEl === 'customerAddressList') {
			if (!isOpenBillingAddress) return;
		} else if (selectedUlEl === 'statesList') {
			if (!isOpenStates) return;
		} else if (selectedUlEl === 'expMonthList') {
			if (!isOpenExpMonth) return;
		} else if (selectedUlEl === 'expYearList') {
			if (!isOpenExpYear) return;
		}

		const keyValue = e.key;
		const newSearch = search + keyValue;
		let searchIndex = [];
		if (/^[a-zA-Z]$/.test(keyValue) && !e.repeat) {
			e.preventDefault();
			if (newSearch.length < 3) {
				setSearch(newSearch);
				statesArray.filter((state, index) => {
					if (state.toLowerCase().startsWith(newSearch.toLowerCase())) {
						searchIndex.push({state: state, index: index});
					}
				})
				setHighlighedIndexStates((prev) => {
					const nextLi = statesListRef.current.querySelectorAll('li')[searchIndex[0].index];
					if (nextLi) {
						nextLi.scrollIntoView({ block: "nearest"})
					}
					return searchIndex[0].index;
				});	
			}

		} else {
			switch (e.key) {
				case 'Backspace':
				case 'Delete':
					e.preventDefault();
				
					const newSearchRemove = search.slice(0, -1);
					setSearch(newSearchRemove);
					statesArray.filter((state, index) => {
						if (state.toLowerCase().startsWith(newSearchRemove.toLowerCase())) {
							searchIndex.push({state: state, index: index});
						}
					})

					let nextLi;
					setHighlighedIndexStates((prev) => {
						let currentSearchIndex; 
						if (searchIndex.length !== 0) {
							currentSearchIndex = searchIndex[0].index;
							nextLi = statesListRef.current.querySelectorAll('li')[searchIndex[0].index]; 
						} else {
							currentSearchIndex = 0;
							nextLi = statesListRef.current.querySelectorAll('li')[0];
						}
						if (nextLi) {
							nextLi.scrollIntoView({ block: "nearest"})
						}
						return currentSearchIndex;
					});	
					break;

				case 'ArrowDown':
					e.preventDefault();
					if (selectedUlEl === 'customerNumberList') {
						setHighlighedIndexCCHolder((prev) => (prev >= ccHolderUpdatedListLength.length - 1 ? 0 : prev + 1));
					} else if (selectedUlEl === 'customerAddressList') {
						setHighlighedIndexBillAddress((prev) => (prev >= billingAddress.length - 1 ? 0 : prev + 1));					
					} else if (selectedUlEl === 'statesList') {
						setHighlighedIndexStates((prev) => {
							const nextIndex = prev >= statesArray.length - 1 ? 0 : prev + 1;
							const nextLi = statesListRef.current.querySelectorAll('li')[nextIndex];
							if (nextLi) {
								nextLi.scrollIntoView({ block: "nearest"})
							}
							return nextIndex;
						});	
					} else if (selectedUlEl === 'expMonthList') {
						setHighlighedIndexExpMonth((prev) => {
							let nextIndex = prev >= expMonthArray.length - 1 ? 0 : prev + 1;
							let nextLi = expMonthListRef.current.querySelectorAll('li')[nextIndex];
							
							while (nextLi) {
								if (!nextLi.classList.contains('wth3-disableItem')) {
									break;
								}
								nextIndex = nextIndex >= expMonthArray.length - 1 ? 0 : nextIndex + 1
								nextLi = expMonthListRef.current.querySelectorAll('li')[nextIndex];
							}

							if (nextLi) {
								nextLi.scrollIntoView({ block: "nearest"})
							}
							return nextIndex;
						});					
					} else if (selectedUlEl === 'expYearList') {
						setHighlighedIndexExpYear((prev) => {
							let nextIndex = prev >= expYearArray.length - 1 ? 0 : prev + 1;
							let nextLi = expYearListRef.current.querySelectorAll('li')[nextIndex];
							while (nextLi) {
								if (!nextLi.classList.contains('wth3-disableItem')) {
									break;
								}
								nextIndex = nextIndex >= expYearArray.length - 1 ? 0 : nextIndex + 1
								nextLi = expYearListRef.current.querySelectorAll('li')[nextIndex];
							}
							if (nextLi) {
								nextLi.scrollIntoView({ block: "nearest"})
							}
							return nextIndex;
						});					
					}
					break;
	
				case 'ArrowUp':
					e.preventDefault();
					if (selectedUlEl === 'customerNumberList') {
						setHighlighedIndexCCHolder((prev) => (prev <= 0 ? ccHolderUpdatedListLength.length - 1 : prev - 1));
					} else if (selectedUlEl === 'customerAddressList') {
						setHighlighedIndexBillAddress((prev) => (prev <= 0 ? billingAddress.length - 1 : prev - 1));	
					} else if (selectedUlEl === 'statesList') {
						setHighlighedIndexStates((prev) => {
							const prevIndex = prev <= 0 ? statesArray.length - 1 : prev - 1;
							const prevLi = statesListRef.current.querySelectorAll('li')[prevIndex];
							if (prevLi) {
								prevLi.scrollIntoView({ block: "nearest"})
							}
							return prevIndex;
						});	
					} else if (selectedUlEl === 'expMonthList') {
						setHighlighedIndexExpMonth((prev) => {
							let prevIndex = prev <= 0 ? expMonthArray.length - 1 : prev - 1;
							let prevLi = expMonthListRef.current.querySelectorAll('li')[prevIndex];
							
							while (prevLi) {
								if (!prevLi.classList.contains('wth3-disableItem')) {
									break;
								}
								prevIndex = prevIndex <= 0 ? expMonthArray.length - 1 : prevIndex - 1
								prevLi = expMonthListRef.current.querySelectorAll('li')[prevIndex];
							}
							prevLi.scrollIntoView({ block: "nearest"})
							return prevIndex;
						});	
					} else if (selectedUlEl === 'expYearList') {
						setHighlighedIndexExpYear((prev) => {
							let prevIndex = prev <= 0 ? expYearArray.length - 1 : prev - 1;
							let prevLi = expYearListRef.current.querySelectorAll('li')[prevIndex];

							while (prevLi) {
								if (!prevLi.classList.contains('wth3-disableItem')) {
									break;
								}
								prevIndex = prevIndex <= 0 ? expYearArray.length - 1 : prevIndex - 1
								prevLi = expYearListRef.current.querySelectorAll('li')[prevIndex];
							}

							if (prevLi) {
								prevLi.scrollIntoView({ block: "nearest"})
							}
							return prevIndex;
						});	
					}
					break;
		
				case 'Enter':
				case ' ':
				case 'Tab':
					e.preventDefault();
					let selectedValue;
					if (selectedUlEl === 'customerNumberList') {
						setSelectedIndexCCHolder(highlighedIndexCCHolder);
						selectedValue = props.updateBooking.makePayment.creditCardHolderList[highlighedIndexCCHolder];
						ccHolderOnChange(selectedValue, null);
					} else if (selectedUlEl === 'customerAddressList') {
						setSelectedIndexBillAddress(highlighedIndexBillAddress);
						selectedValue = billingAddress[highlighedIndexBillAddress];
						ccBillingAddressOnChange(selectedValue, null)
						
						if (selectedValue.addressNumber === 'new') {
							getStates();
						}
					} else if (selectedUlEl === 'statesList') {
						setSelectedIndexState(highlighedIndexStates);
						selectedValue = statesArray[highlighedIndexStates];
						updateState(selectedValue, null);
					} else if (selectedUlEl === 'expMonthList') {
						setSelectedIndexExpMonth(highlighedIndexExpMonth);
						selectedValue = expMonthArray[highlighedIndexExpMonth];
						popYear(selectedValue, null);	
					} else if (selectedUlEl === 'expYearList') {
						setSelectedIndexExpYear(highlighedIndexExpYear);
						selectedValue = expYearArray[highlighedIndexExpYear];
						updateYear(selectedValue, null);	
					}
					break;
				case 'Escape':
					e.preventDefault();
					if (selectedUlEl === 'customerNumberList') {
						setIsOpenCCHolder(false);
						setHighlighedIndexCCHolder(-1);
						ccHolderContainerEl.focus();
					} else if (selectedUlEl === 'customerAddressList') {
						setIsOpenBillingAddress(false);
						setHighlighedIndexBillAddress(-1);
						billAddressContainerEl.focus();
					} else if (selectedUlEl === 'statesList') {
						setIsOpenStates(false);
						setHighlighedIndexStates(-1);
						statesContainerEl.focus();
					} else if (selectedUlEl === 'expMonthList') {
						setIsOpenExpMonth(false);
						setHighlighedIndexExpMonth(-1);
						expMonthContainerEl.focus();
					} else if (selectedUlEl === 'expYearList') {
						setIsOpenExpYear(false);
						setHighlighedIndexExpYear(-1);
						expYearContainerEl.focus();
					}
	
					break;
	
				default:
					break;
			}
		}
	}

	const updateError = (errorName, isError) => {
		setPaymentErrors(prev => ({
			...prev,
			[errorName]: isError
		}))
	};

	const removeErrorOutline = (e, elId) => {
		e.preventDefault();
		const targetEl = document.getElementById(elId);
		targetEl.style.outline = 'none';
		targetEl.style.outlineOffset = 'none';
	}

	const errorHandeScrollInto = (e, elId) => {
		e.preventDefault();
		let targetEl = document.getElementById(elId);
		
		if (targetEl.id === 'css_yes_insurance' || targetEl.id === 'css_remainingBalancePayment') {
			targetEl.parentNode.style.outline = '2px dotted black';
			targetEl.parentNode.style.outlineOffset = '2px';

			if (targetEl.id === 'css_yes_insurance') {
				document.getElementById('css_insuranceChoice').scrollIntoView({block: "end"});
			}
			
			if (targetEl.id === 'css_remainingBalancePayment') {
				document.getElementById('css_paymentChoiceContainer').scrollIntoView({block: "end"});
			}
		} else {
			targetEl.style.outline = '2px dotted black';
			targetEl.style.outlineOffset = '2px';
		}
		targetEl.focus();
	}

	const onChangeCVVField = (e) => {
		e.target.value = e.target.value.replace(/[^0-9]/g, '')
	}	

	useEffect(() => {
		// Handle outside container clicks
		const handleClickOutside = (e) => {
			if (refCCHOlderContainer.current && !refCCHOlderContainer.current.contains(e.target) && 
			refCCHolderList.current && !refCCHolderList.current.contains(e.target)) {
				setIsOpenCCHolder(false);
				setHighlighedIndexCCHolder(-1);
			}

			if (refBillAddressContainer.current && !refBillAddressContainer.current.contains(e.target) && 
			billingListRef.current && !billingListRef.current.contains(e.target)) {
				setIsOpenBillingAddress(false);
				setHighlighedIndexBillAddress(-1);
			}

			if (refStatesContainer.current && !refStatesContainer.current.contains(e.target) && 
			statesListRef.current && !statesListRef.current.contains(e.target)) {
				setIsOpenStates(false);
				setHighlighedIndexStates(-1);
			}

			if (refExpMonthContainer.current && !refExpMonthContainer.current.contains(e.target) && 
			expMonthListRef.current && !expMonthListRef.current.contains(e.target)) {
				setIsOpenExpMonth(false);
				setHighlighedIndexExpMonth(-1);
			}

			if (refExpYearContainer.current && !refExpYearContainer.current.contains(e.target) && 
			expYearListRef.current && !expYearListRef.current.contains(e.target)) {
				setIsOpenExpYear(false);
				setHighlighedIndexExpYear(-1);
			}
		}

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const focusInput = (e, fieldName) => {
		e.preventDefault();
		if (inputRefs.current[fieldName]) {
			inputRefs.current[fieldName].focus();
		}
	};

	const handleKeyDownInput = (e, fieldName) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			focusInput(fieldName);
		}
	}

	const contentId = 'expandCollapseCont'
	const [isExpanded, setIsExpanded] = useState(true);
	
	const toggleExpand = () => {
		setIsExpanded(prev => !prev);
	}
	
	const handleKeyDownSummaryCharges = (e) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			toggleExpand();
		}
	}
	

	const handleRadioBtnFocus = (e) => {
		const checkmarkEl = e.target.id
		if (checkmarkEl && checkmarkEl === 'css_yes_insurance') {
			document.querySelector('#css_yes_insurance').nextSibling.classList.add('wth3-focused-style');
			document.querySelector('#css_no_insurance').nextSibling.classList.remove('wth3-focused-style');
		} else if (checkmarkEl && checkmarkEl === 'css_no_insurance') {
			document.querySelector('#css_no_insurance').nextSibling.classList.add('wth3-focused-style');
			document.querySelector('#css_yes_insurance').nextSibling.classList.remove('wth3-focused-style');
		} else if (checkmarkEl && checkmarkEl === 'css_remainingBalancePayment') {
			document.querySelector('#css_remainingBalancePayment').nextSibling.classList.add('wth3-focused-style');
			document.querySelector('#css_otherAmountPayment').nextSibling.classList.remove('wth3-focused-style');
		} else if (checkmarkEl && checkmarkEl === 'css_otherAmountPayment') {
			document.querySelector('#css_otherAmountPayment').nextSibling.classList.add('wth3-focused-style');
			document.querySelector('#css_remainingBalancePayment').nextSibling.classList.remove('wth3-focused-style');
		}
	}

	const handleRadioBtnBlur = (e) => {
		document.querySelectorAll('.wth3-radioCircle').forEach((el) => {
			el.classList.remove('wth3-focused-style');
		})
	}

	const isMobileOrDesktop = useEffectMobileSummaryCharges();

     const dispatch = useDispatch();
     useEffect(() => {
		if (props.updateBooking.makePayment.creditCardHolderList !== undefined) {
			setCCHolderUpdatedListLength(props.updateBooking.makePayment.creditCardHolderList.filter((guest) => guest.creditCardHolder));

		}
		
    	 dispatch(totalcostset(Number(props.updateBooking.bookingSummary.charges.totalCost)));
    	 if(props.updateBooking.bookingSummary.charges.insurance.include===true){
    		 dispatch(insuranceStatusIncluded());
    		 if(props.updateBooking.bookingSummary.charges.insurance.vendor.name === "LEISURECARE") {
    			 	dispatch(insuranceVendorLeisure());
				}
				else{
					dispatch(insuranceVendorOther(props.updateBooking.bookingSummary.charges.insurance.vendor.name));
				}
         }
         else{
        	 dispatch(insuranceStatusNotIncluded());
         }    	 if(props.updateBooking.bookingSummary.charges.remainingBalance.toString().indexOf("-")>=0){
    		 dispatch(remainingBalanceNegativeTrue());
         }
    	 if(isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===true){    		 
    		 dispatch(bookingPastDueTrue());
    	 }
    	 if(remainingBalanceNegative===false && props.updateBooking.bookingSummary.charges.remainingBalance!==0){
         	dispatch(balanceDueTrue());
         	dispatch(remainingBalanceSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));
         	dispatch(remainingBalanceAsFloatSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));         	
             if (isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false){
				if (props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean') {
					dispatch(paymentDueSet("Payment due " + getFormattedDate(props.updateBooking.bookingSummary.charges.paymentDueDate)));
				}
     		}
         }
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
	    	 if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==null && props.updateBooking.makePayment.paymentOptions.payRemainingBalance!=='' && typeof(props.updateBooking.makePayment.paymentOptions.payRemainingBalance)!=="undefined"){
	    		 dispatch(payRemainingBalanceValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	    		 dispatch(balancePayRemainingValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	    	}
    	 }
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('makeMinimumPayment')){
	    	 if(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment!==null && props.updateBooking.makePayment.paymentOptions.makeMinimumPayment!=='' && typeof(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment)!=="undefined"){
	     		dispatch(minimumPaymentAmountValue(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment));
	     	}
    	 }
    	 dispatch(bookingDueTodayAnswer(isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)));
    	 if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
	    	if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance>=props.updateBooking.makePayment.paymentOptions.makeMinimumPayment && isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false && isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)===false){
	    		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
	     	else if((props.updateBooking.makePayment.paymentOptions.payRemainingBalance>=props.updateBooking.makePayment.paymentOptions.makeMinimumPayment && isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===false && isDueToday(props.updateBooking.bookingSummary.charges.paymentDueDate)===true) || (props.updateBooking.makePayment.paymentOptions.payRemainingBalance===0 && props.updateBooking.bookingSummary.quoteInsuranceInd==='Y')) {
	     		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
	     	else if (isPastDue(props.updateBooking.bookingSummary.charges.paymentDueDate)===true) {
	     		dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
	     	}
    	 }
     }, [dispatch]);

	const getStates = () => {
		if (!isOpenStates) {
			setStatesArray([]);
			let stateListComplete = '';
			let url = '/wthrest/customer-self-service/getStates.rs';
			fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				}
			}).then(stateResponse => stateResponse.json()).then(stateResponse => {
				setStateList(stateResponse);
			}).catch(error => {
			});
		}
	}
    
    function setStateList(stateListResponse) {
		Object.keys(stateListResponse.states).forEach(function(key) {
			setStatesArray(prevArray => [...prevArray, stateListResponse.states[key].code]);
		});
	}

	const updateState = (selectedState, index) => {
		setSelectedOptionStatesName(selectedState);
		setIsOpenStates(false);
		setHighlighedIndexStates(-1);
		if (index !== null) {
			setSelectedIndexState(index);
		}
		statesContainerEl.focus();
	}

	function otherAmountChange() {
		let customerValue = document.getElementById("otherAmountPaymentInputField").value;
		if (customerValue) {
			setSelectedPaymentOption('Custom Amount');
			dispatch(paymentOtherUpdate(customerValue));
		}
		if(customerValue !== null && customerValue !==''){
			document.getElementById('css_remainingBalancePayment').checked=false;
			document.getElementById('css_otherAmountPayment').checked=true;
			customerValue = customerValue.replace(/,/g, '');
		}
		dispatch(paymentAmountUpdater(customerValue));
	}
     
     function ccHolderOnChange(guest, index) {
    	 	let setVal = guest.customerNumber;
			if(setVal !=='' && setVal !== 'undefined' && setVal !== null){
				dispatch(ccHolderForVerificationNameUpdate(document.getElementById("css_paxChoice_" + setVal).innerHTML));
				setSelectedOptionCCName(() => ({
					ccHolderName: `${noCase(guest.firstName)} ${noCase(guest.lastName)}`, 
					ccHolderNumber: guest.customerNumber
				}));
				setIsOpenCCHolder(false);
				setHighlighedIndexCCHolder(-1);
				ccHolderContainerEl.focus();
				if (index !== null) {
					setSelectedIndexCCHolder(index);
				}
			}
			else{
				dispatch(ccHolderForVerificationNameUpdate(''));
			}
			if(setVal === '' || typeof setVal === 'undefined'){
				dispatch(showOtherInputFieldsFalse());
				dispatch(showBillingAddressDropFalse());
				dispatch(showBillingAddressFieldsFalse());
				if(document.getElementById("css_cc_otherFirstName")){
					document.getElementById("css_cc_otherFirstName").value='';
					document.getElementById("css_cc_otherLastName").value='';
					document.getElementById("css_cc_otherMI").value='';
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
			}
			else if (setVal === 'other'){
				dispatch(showOtherInputFieldsTrue());
				dispatch(showBillingAddressDropFalse());
				dispatch(showBillingAddressFieldsTrue());
			}
			else {		
				dispatch(showOtherInputFieldsFalse());
				if(document.getElementById("css_cc_otherFirstName")){
					document.getElementById("css_cc_otherFirstName").value='';
					document.getElementById("css_cc_otherLastName").value='';
					document.getElementById("css_cc_otherMI").value='';
					document.getElementById("css_address1").value='';
					document.getElementById("css_address2").value='';
					document.getElementById("css_city").value='';
					document.getElementById("css_paymentState").value='';
					document.getElementById("css_zip").value='';
				}
	
				dispatch(showBillingAddressFieldsFalse());
				 setTimeout(() => {

					 Object.keys(props.updateBooking.makePayment.creditCardHolderList).forEach(function(key){
							let valueFirstName = props.updateBooking.makePayment.creditCardHolderList[key].firstName;
							let valueLastName = props.updateBooking.makePayment.creditCardHolderList[key].lastName;
							let valueName = valueFirstName.toLowerCase() + " " + valueLastName.toLowerCase();
							//eslint-disable-next-line
							if(props.updateBooking.makePayment.creditCardHolderList[key].customerNumber == setVal || valueName == setVal){		
								Object.keys(props.updateBooking.makePayment.creditCardHolderList[key].addresseList).forEach(function(key2){
									if(props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 === null || props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 === ''){
										props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2='';
									}
									else{
										if (props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2.slice(-1) !== ",")
											{
												props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2=props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 + ', ';
											}
									}
									if(props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address1 !== ''){
										setBillingAddress([]);
										setBillingAddress(prevItems => [...prevItems, 
											{ 
												address: props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address1 + ", " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].address2 + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].city + ", " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].state + " " + props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].zipCode,
												addressNumber: props.updateBooking.makePayment.creditCardHolderList[key].addresseList[key2].addressNumber
											}
										]);
									}
								});
								setBillingAddress(prevItems => [...prevItems, 
									{ 
										address: 'Enter a new billing address',
										addressNumber: 'new'
									}
								]);
								dispatch(showBillingAddressDropTrue());
							}
						});
					
				 }, 500);
				
			}
			
		
		}
     
    function ccBillingAddressOnChange(address, index) {
		let setValue = address.addressNumber;
		if (setValue === 'new') {
			setSelectedOptionBillingAddress(() => ({address: 'Enter a new billing address', addressNumber: 'new'}));
			setDefaultBillingText('Enter a new billing address');
			getStates();
			setIsOpenBillingAddress(false);
			setHighlighedIndexBillAddress(-1);
			billAddressContainerEl.focus();
		} else {
			setSelectedOptionBillingAddress(() => ({address: address.address, addressNumber: address.addressNumber}));
			setIsOpenBillingAddress(false);
			setHighlighedIndexBillAddress(-1);
			billAddressContainerEl.focus();
		}

		if (index !== null) {
			setSelectedIndexBillAddress(index);
		}
		
		
		dispatch(ccBillingAddressForVerificationUpdate(setValue));
			if(setValue!=='new' && setValue!=='' && typeof(setValue) !== 'undefined'){
				dispatch(ccBillingAddressForVerificationUpdate(document.getElementById("css_addressChoice_" + setValue).innerHTML));
		}

		
			if(setValue === '' || typeof(setValue) === 'undefined'){
			if(document.getElementById("css_address1")){
				document.getElementById("css_address1").value='';
				document.getElementById("css_address2").value='';
				document.getElementById("css_city").value='';
				document.getElementById("css_paymentState").value='';
				document.getElementById("css_zip").value='';
			}
			dispatch(showBillingAddressFieldsFalse());
		} else if (setValue === 'new'){
			dispatch(showBillingAddressFieldsTrue());
		} else {	
			if(document.getElementById("css_address1")){
				document.getElementById("css_address1").value='';
				document.getElementById("css_address2").value='';
				document.getElementById("css_city").value='';
				document.getElementById("css_paymentState").value='';
				document.getElementById("css_zip").value='';
			}
			dispatch(showBillingAddressFieldsFalse());
							
		}
	}

	const updateYear = (yearVal, index) => {
		setSelectedOptionExpYear(yearVal);
		setIsOpenExpYear(false);
		setHighlighedIndexExpYear(-1);
		if (index !== null) {
			setSelectedIndexExpYear(index);
		}
		expYearContainerEl.focus();
	}

    function populateYear(month) {
		let today = DateTime.now();
		let currentMonth = today.month;
		let yearsArray = [];
		setExpYearArray(['YYYY']);
		let startYear = '';
		if (parseInt(month) < currentMonth) {
			for(let i=0;i<20;i++){
				startYear = today.year + i + 1;					
				yearsArray.push(startYear);
			}
		} else {
			for(let i=0;i<20;i++){
				startYear = today.year + i;
				yearsArray.push(startYear);
			}
		}
		setExpYearArray((prevArray) => [...prevArray, ...yearsArray]);
		setSelectedOptionExpYear('')
	}

    function popYear(monthVal, index) {
		setSelectedOptionExpMonth(monthVal);
		if (monthVal === '' || monthVal === 'undefined' || monthVal === null){
			document.getElementById("ccYear").innerHTML("");
		} else{
			setIsOpenExpMonth(false);
			setHighlighedIndexExpMonth(-1);
			if (index !== null) {
				setSelectedIndexExpMonth(index);
			}
			expMonthContainerEl.focus();
			populateYear(parseInt(monthVal));			
		}
	}
     function clearOtherField(){
			document.getElementById('otherAmountPaymentInputField').value = '';
			dispatch(paymentOtherUpdate(""));
		}
     function changePaymentChoiceOther(){
			otherAmountChange("");
			otherAmountChange(paymentOther);
			dispatch(paymentOptionOther());
			// document.getElementById('css_remainingBalancePaymentLabel').classList.remove('wth2_css_radio_selected');
			// document.getElementById('css_remainingBalancePaymentLabel').classList.add('wth2_css_radio_notselected');
			// document.getElementById('css_otherAmountPaymentLabel').classList.remove('wth2_css_radio_notselected');
			// document.getElementById('css_otherAmountPaymentLabel').classList.add('wth2_css_radio_selected');
			document.getElementById('css_remainingBalancePayment').checked=false;
			document.getElementById('css_otherAmountPayment').checked=true;

			if(document.getElementById("css_amountPaidContainer")){
				document.getElementById("css_amountPaidContainer").style.display = 'none';
			}
			
			dispatch(paymentOtherActiveTrue());
			dispatch(paymentAmountUpdater(0));
		}

	function changePaymentChoiceFull(){
		if (document.getElementById("css_otherAmountPayment")){
			otherAmountChange("");
			otherAmountChange(paymentOther);
		}

		if (document.getElementById("css_amountPaidContainer")){
			document.getElementById("css_amountPaidContainer").style.display = 'none';
		}
		dispatch(paymentOptionFull());
		//timeout to safely handle paid in full bookings that need to display payment form after insurance addition
		setTimeout(function(){ 
			if(document.getElementById("css_otherAmountPayment")){
				document.getElementById("otherAmountPaymentInputField").value ='';
				document.getElementById('css_otherAmountPayment').checked=false;
			}
			if(document.getElementById('css_remainingBalancePayment')){
				setSelectedPaymentOption('Pay Remaining Balance');
				document.getElementById('css_remainingBalancePayment').checked=true;
			}
		
		}, 500);
		
		dispatch(paymentOtherActiveFalse());						
		if(css_ins === 'Y'){
			if (props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.hasOwnProperty("payRemainingBalance")){
				dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
			} else {
				if(props.updateBooking.insuranceQuote.makePaymentWithInsurance.hasOwnProperty('priceAmount')){
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.priceAmount));
				}
			}
		} else {
			if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
				dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
			}
		}
	}

     function changeInsuranceChoice(insuranceOption){
			if(insuranceOption==='yes'){	
				setMessage8HelpVal(`Travel insurance will be added to your booking once the LeisureCare plan cost is paid in full. Please make a ${payRemainingBalance>=25  ? 'minimum ' : ''}payment to continue`);

				setTravelInsurance('yes');

				dispatch(paidInFullLanguageUpdater('Remaining Balance'));
				if (props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25){
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.makeMinimumPayment));;
				}
				dispatch(css_insAdd());
				dispatch(includeInsuranceBalanceNoteUpdate('Your Updated Balance with Travel Insurance:'));
				dispatch(message8DisplayPropertyDisplay());

				setTimeout(() => {
					document.querySelector('#message8').scrollIntoView({block: 'end'});
					setMessage8HelpVal(prev => prev + '.');
				}, 100);
				props.CallTracker("Customer Self Service", "Insurance", "With Insurance");
				document.getElementById('css_yes_insurance').checked = true;
				document.getElementById('css_no_insurance').checked = false;
				dispatch(totalcostset(parseFloat(props.updateBooking.bookingSummary.charges.totalCost) + parseFloat(props.updateBooking.insuranceQuote.priceAmount)));
				dispatch(insuranceStatusPaymentRequired());
				dispatch(remainingBalanceSet(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payBalanceExcludeFuturePayments));

				dispatch(remainingBalanceAsFloatSet(parseFloat(remainingBalance)));
				if(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.hasOwnProperty("makeMinimumPayment")){
					dispatch(minimumPaymentAmountValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.makeMinimumPayment));
				}
				else{
					dispatch(minimumPaymentAmountValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				}
				dispatch(balancePayRemainingValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				dispatch(payRemainingBalanceValue(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
				
				if(payRemainingBalance===props.updateBooking.insuranceQuote.priceAmount){
					changePaymentChoiceFull();
					dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payBalanceIncludeFuturePayments));
					
				}
				else{
					if (paymentOption === "Full"){
						changePaymentChoiceFull();
						dispatch(paymentAmountUpdater(props.updateBooking.insuranceQuote.makePaymentWithInsurance.paymentOptions.payRemainingBalance));
					}
					else if (paymentOption === 'Other') {
						changePaymentChoiceOther();
						dispatch(paymentAmountUpdater(0));
						document.getElementById('otherAmountPaymentInputField').value='';
						dispatch(paymentOtherUpdate(""));
					}
				}
			}
			else{
				setTravelInsurance('no');
				dispatch(css_insRemove());
				if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25 && css_ins==='Y') {
					dispatch(paymentOptionClear());
				}
				if(props.updateBooking.bookingSummary.charges.remainingBalance===0){
					dispatch(paidInFullLanguageUpdater('Paid in Full'));
				}
				else if (props.updateBooking.makePayment.paymentOptions.payRemainingBalance<25){
					dispatch(paymentAmountUpdater(0));
				}
				dispatch(includeInsuranceBalanceNoteUpdate('Your Updated Balance without Travel Insurance:'));
				dispatch(message8DisplayPropertyHide());

				if (document.querySelector('#message8').style.display !== 'none') {
					setTimeout(() => {
						setMessage8HelpVal(prev => prev.slice(0, -1));
					}, 100);
				}
				
				props.CallTracker("Customer Self Service", "Insurance", "Without Insurance");
				document.getElementById('css_no_insurance').checked=true;
				document.getElementById('css_yes_insurance').checked=false;
				dispatch(totalcostset(props.updateBooking.bookingSummary.charges.totalCost));
				dispatch(insuranceStatusNotIncluded());
				dispatch(remainingBalanceSet(props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments));
				dispatch(remainingBalanceAsFloatSet(parseFloat(remainingBalance)));
				if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('makeMinimumPayment')){
					dispatch(minimumPaymentAmountValue(props.updateBooking.makePayment.paymentOptions.makeMinimumPayment));
				}
				if(props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==null&&props.updateBooking.makePayment.paymentOptions.payRemainingBalance!==''&&typeof(props.updateBooking.makePayment.paymentOptions.payRemainingBalance)!=="undefined"){
					dispatch(payRemainingBalanceValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
					dispatch(balancePayRemainingValue(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
				}
				else{
					dispatch(payRemainingBalanceValue(0));
					dispatch(balancePayRemainingValue(0));
				}
				if (paymentOption === "Full"){
					changePaymentChoiceFull();
					if(props.updateBooking.makePayment.paymentOptions.hasOwnProperty('payRemainingBalance')){
						dispatch(paymentAmountUpdater(props.updateBooking.makePayment.paymentOptions.payRemainingBalance));
					}
				}
				else if (paymentOption === 'Other') {
					changePaymentChoiceOther();
					dispatch(paymentAmountUpdater(0));
					document.getElementById('otherAmountPaymentInputField').value ='';
					dispatch(paymentOtherUpdate(""));
				}
		
			}
		}
     const Tooltip =
		  <Popup
		    trigger={open => (
				//eslint-disable-next-line
		    		<a href="javascript:void(0);" tabindex="0" id="cvvInfo" className="button wth2-csscvvInfo"><i aria-hidden="true" id="cvvIcon" class="fa fa-info-circle wth2-cvvIcon"></i></a>
		    )}
		    modal
		    nested
		    closeOnDocumentClick
		  >
     		{close => (
    	      <div className="modal wth3-pop cvvModalPopup">
	    	    <div>
			    	<a id="cvvClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right ui-link wth3-popClose" role="button" title="Close" onClick={e=> {e.preventDefault();close()}}> </a>
				    
			    	<h5 id="cvvHeaderDescriptor" class="wth3-popuphead">How do I find my CVV number?</h5>
			    	<div class="wth2-cvvPopUpContainer">
			    		<h5 id="cvvHeader" class="wth2-simplePopupHeader">Visa, Mastercard,<br />Discover (3 digits)</h5>
					    <p id="cvvContent" class="wth2-simplePopupContent wth2-popupDatesContent">
					    	<img src="/images_unique/css/Visa-MC-Disc.png" id="cc_cvvPopUpImageVisa" class="wth2-css_cvvPopUpImage" alt="Credit card logos"/>       
					    </p>
					 </div>
					 <div class="wth2-cvvPopUpContainer">
					    <h5 id="cvvHeader2" class="wth2-simplePopupHeader">American Express<br />(4 digits)</h5>	
				    	<p id="cvvContent2" class="wth2-simplePopupContent wth2-popupDatesContent">
				    		<img src="/images_unique/css/AmEx.png" id="cc_cvvPopUpImageAmex" class="wth2-css_cvvPopUpImage" alt="American Express Logo"/>
				    	</p>
					  </div>					
				</div>
    	        
    	      </div>
    	    )}
    	  </Popup>;
    	  const Tooltip2 =
    		  <Popup
    		    trigger={open => (
					//eslint-disable-next-line
    		    		<a href="javascript:void(0);" tabindex="0" id="termsandconditions" className="wth2-css_viewTerms">View Terms &amp; Conditions</a>
    		    )}
    		    modal
    		    nested
    		    closeOnDocumentClick
    		  >
         		{close => (
        	      <div className="modal termsAndConditionsModal">	        	     
	        	      <a id="termsandconditionsClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth3-popClose" role="button" title="Close" onClick={e=>{e.preventDefault();close();}}> </a>
	        	      <h5 id="termsandconditionsHeader" class="wth2-simplePopupHeader">Terms &amp; conditions</h5>
	        	      <p id="termsandconditionsContent" class="wth2-simplePopupContent wth2-popupDatesContent">Your reservation is subject to cancellation fees and change fees as indicated at time of booking. Subsequent payments to this reservation are pending, based on credit approval. We will contact you only in the event that your payment is not approved. Travel insurance is available to U.S. and Canadian residents only, and may be added to your reservation prior to travel start date up until 10 days after final payment is received. Travel insurance is non-refundable and can only be purchased for all travelers on the reservation.</p>
	        	  </div>
        	    )}
        	  </Popup>;
        	  const Tooltip3 =
        		  <Popup
        		    trigger={open => (
						//eslint-disable-next-line
        		    	<a href="javascript:void(0);" tabindex="0" className="wth2-css_viewTerms visuallyhidden" id="openInsurancePop">ins</a>
        		    )}
        		    modal
        		    nested
        		    closeOnDocumentClick
        		  >
             		{close => (
            	      <div className="modal insuranceModal">	        	     
    	        	      <a id="insuranceClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth3-popClose" role="button" title="Close" onClick={e=>{e.preventDefault();close()}}> </a> 
    	        	      <h5 id="insuranceAlertHeader" class="wth2-simplePopupHeader">Finish Adding LeisureCare Travel Insurance?</h5>
    	        	      <p id="insuranceAlertContent" class="wth2-simplePopupContent wth2-popupDatesContent">
	    	      	    	<div class="wth2-warningMessage"><div class="wth2-warningMessageHeader"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Please make a {bookingPastDue===false && props?.updateBooking?.bookingSummary?.charges?.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===false && minimumPaymentAmount!==payRemainingBalance && <span>minimum</span>} payment of {bookingPastDue===true && <span><NumberFormat value={remainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>}{bookingPastDue===false && <span><NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>} to add LeisureCare Travel Insurance to your booking now.</div>
	    	      	    	</div>		
			    	      		<div class="wth_css_popButtons"><button id="cssNoThanksButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini" onClick={() => { props.onChangeView('summary-swapInsurance', props.booking, '')} } >No Thanks</button><button id="cssMakePaymentNowButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth2-ui-btn" onClick={close}>Make Payment Now</button></div>	
		    	      	    </p>
    	        	  </div>
            	    )}
            	  </Popup>;

	function checkInsurance(){
		if (props.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y') {
			if(css_ins==='Y'){
				document.getElementById("openInsurancePop").click();
			}
			else{
				props.onChangeView('new-summary', props.booking, '');
			}
		} else {
			if(css_ins==='Y'){
				document.getElementById("openInsurancePop").click();
			}
			else{
				props.onChangeView('summary-swap', props.booking, '');
			}
		}
	}

	//START CREDIT CARD VALIDATION SHARED SCRIPT
	function isVisa(cc) {
		if (((cc.length === 16) || (cc.length === 13)) &&
			(cc.substring(0,1) === '4'))
		return true;
	}  

	function isMasterCard(cc) {
		let firstdig = cc.substring(0,1);
		let seconddig = cc.substring(1,2);
		if (((cc.length == 16) && (firstdig == 5) &&
			(seconddig >= 1) && (seconddig <= 5))
			||((cc.length == 16) && (firstdig == 2) &&
			(seconddig >= 2) && (seconddig <= 7)))
		return true;
	}

	function isAmericanExpress(cc) {
		let firstdig = cc.substring(0,1);
		let seconddig = cc.substring(1,2);
		if (((cc.length === 15) && (firstdig === '3')) &&
			((seconddig === '4') || (seconddig === '7')))
		return true;

	} 


	function isDiscover(cc) {
		let first4digs = cc.substring(0,4);
		let first3digs = cc.substring(0,3);
		let first2digs = cc.substring(0,2);
		if (((cc.length === 16) && (first4digs === "6011"))
			||((cc.length === 16) && (first3digs === "644"))
			||((cc.length === 16) && (first2digs === "65")))
		return true;
	} 

	function isAnyCard(cc) {
		if (!isMasterCard(cc) && !isVisa(cc) && !isAmericanExpress(cc) &&
			!isDiscover(cc)) {
			return false;
		}
		return true;

	}        
	
	//END CREDIT CARD VALIDATION SHARED SCRIPT
			
	function isExpDateFail(month, year){
		let today = new Date();
		let expDate = new Date(year, month, 0, 23, 59, 59);
		if (today>expDate) {
			//fail
			return true;
		} else {
			return false;
		}
	}

	function isExpDateWithin5Days(month, year){
		let today2 = new Date();
		let lastDayOfMonth = new Date(today2.getFullYear(), today2.getMonth()+1, 0);	
		let differencelastday = lastDayOfMonth.getDate() - today2.getDate();
		if(month-1 === today2.getMonth() && year === today2.getFullYear()){
			if(differencelastday <=5) {
				//fail
				return true
			}
			else {
			return false;
			}    
		}
		
	}

	function isInsuranceChoiceValid() {
		let insuranceChoiceValidState = false;
		if (props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!==''){
			if(document.getElementById("css_yes_insurance").checked===true||document.getElementById("css_no_insurance").checked===true){
				document.getElementById("css_paymentErrorMessage_selectInsurance").style.display='none';
				updateError('isInsuranceChoice', false);
				insuranceChoiceValidState = true;
			} else {
				document.getElementById("css_paymentFormError").style.display='block';
				document.getElementById("css_paymentErrorMessage_selectInsurance").style.display='block';
				updateError('isInsuranceChoice', true);
				document.getElementById("css_paymentFormError").scrollIntoView();
				props.CallTracker("Customer Self Service", "Errors", "Select an option for Travel Insurance");
				insuranceChoiceValidState = false;
			}
		} else {
			insuranceChoiceValidState = true;
		}
		
		return insuranceChoiceValidState;
	}

	  
	function isPaymentAmountValid() {
		let paymentAmountValidState = false;
		if (document.getElementById("css_otherAmountPayment")){
			if (document.getElementById("css_otherAmountPayment").checked===true){
				let otherAmountValueEntered=document.getElementById("otherAmountPaymentInputField").value.trim();
				let otherAmountRegex=/^[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/   			
				if (otherAmountValueEntered === null || otherAmountValueEntered === ''||otherAmountValueEntered.length<2||!otherAmountRegex.test(otherAmountValueEntered)){
					document.getElementById("css_paymentFormError").style.display='block';

					document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='block';
					updateError('isPaymentAmount', true);
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
					document.getElementById("css_paymentFormError").scrollIntoView();
					props.CallTracker("Customer Self Service", "Errors", "Enter valid payment amount");
					paymentAmountValidState=false;
				} else if (otherAmountValueEntered > payRemainingBalance){
					document.getElementById("css_paymentFormError").style.display='block';

					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='block';
					updateError('isPaymentAmount', true);
					document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
					document.getElementById("css_paymentFormError").scrollIntoView();
					props.CallTracker("Customer Self Service", "Errors", "Enter payment amount equal to or less than" + <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />);
					paymentAmountValidState=false;
				} else if (otherAmountValueEntered < minimumPaymentAmount){
					document.getElementById("css_paymentFormError").style.display='block';

					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='block';
					updateError('isPaymentAmount', true);
					document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
					document.getElementById("css_paymentFormError").scrollIntoView();
					props.CallTracker("Customer Self Service", "Errors", "Enter payment amount $25.00 or greater");
					paymentAmountValidState=false;
				} else {
					if (document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
						document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
						document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
						document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
					}
					if (document.getElementById("otherAmountPaymentInputField")){
						updateError('isPaymentAmount', false);
					}
					paymentAmountValidState=true;
					
				}
				
			} else {
				if (document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
					document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
					document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
				}
				if (document.getElementById("otherAmountPaymentInputField")){
					updateError('isPaymentAmount', false);
				}
				paymentAmountValidState=true;
			}
		} else {
			if (document.getElementById("css_paymentErrorMessage_validPaymentAmount")){
				document.getElementById("css_paymentErrorMessage_validPaymentAmount").style.display='none';
				document.getElementById("css_paymentErrorMessage_validPaymentAmountTooMuch").style.display='none';
				document.getElementById("css_paymentErrorMessage_validPaymentAmountTooLittle").style.display='none';
			}

			if (document.getElementById("otherAmountPaymentInputField")){
				updateError('isPaymentAmount', false);
			}
			paymentAmountValidState=true;
		}
		
		return paymentAmountValidState;
	}

	function isAddress1Valid() {
		let address1ValidState = false;
		if (showBillingAddressFields){
			let address1Value = address1InputValue;
			let address1RegEx = /^[ A-Za-z0-9.#'-]*$/;
			if (address1Value===null||address1Value===''||address1Value.length>30||address1Value.length<2||!address1RegEx.test(address1Value)){	  			
				document.getElementById("css_paymentFormError").style.display='block';
				document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='block';
				updateError('isAddress1', true);
				document.getElementById("css_paymentFormError").scrollIntoView();
				props.CallTracker("Customer Self Service", "Errors", "Enter valid street address 1");
				address1ValidState=false;	  			
			} else {
				document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='none';
				updateError('isAddress1', false);
				address1ValidState=true;
			}	  		
		} else {
			if (document.getElementById("css_paymentErrorMessage_validStreetAddress1")){	  	
				document.getElementById("css_paymentErrorMessage_validStreetAddress1").style.display='none';
			}
			if (document.getElementById("css_address1Container")){
				updateError('isAddress1', false);
			}
				address1ValidState=true;
			
		}
		
		return address1ValidState;
	}
	  
	function isAddress2Valid(){
		let address2ValidState = true;
		if (document.getElementById("css_address2")){
			let address2Value = address2InputValue;
			if (showBillingAddressFields & address2Value !==null && address2Value !== ''){	
				let address2RegEx = /^[ A-Za-z0-9.#'-]*$/;
				if (address2Value.length>30||address2Value.length<2||!address2RegEx.test(address2Value)){	  			
					document.getElementById("css_paymentFormError").style.display='block';
					document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='block';
					updateError('isAddress2', true);
					document.getElementById("css_paymentFormError").scrollIntoView();
					props.CallTracker("Customer Self Service", "Errors", "Enter valid street address 2");
					address2ValidState=false;	  			
				} else {	  			
					document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='none';
					updateError('isAddress2', false);
					address2ValidState=true;
				}	  		
			} else {
				if(document.getElementById("css_paymentErrorMessage_validStreetAddress2")){	  	
					document.getElementById("css_paymentErrorMessage_validStreetAddress2").style.display='none';
				}
				if(document.getElementById("css_address2Container")){
					updateError('isAddress2', false);
				}
					address2ValidState=true;
				
			}
		}

		return address2ValidState;
	}

	function isCityValid() {
	  	let cityValidState = false;
	  	if(showBillingAddressFields){
	  		let cityValue = cityInputValue;
	  		let cityRegEx = /^[ A-Za-z0-9.#'-]*$/;
	  		if (cityValue===null||cityValue===''||cityValue.length>30||cityValue.length<2||!cityRegEx.test(cityValue)){	  			
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_validCity").style.display='block';
				updateError('isCity', true);
	  			document.getElementById("css_paymentFormError").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Enter valid city");
	  			cityValidState=false;	  			
	  		} else {	  			
	  			document.getElementById("css_paymentErrorMessage_validCity").style.display='none';
	  			updateError('isCity', false);
	  			cityValidState=true;
	  		}	  		
	  	} else {
	  		if (document.getElementById("css_paymentErrorMessage_validCity")){	  	
		  		document.getElementById("css_paymentErrorMessage_validCity").style.display='none';
	  		}

	  		if (document.getElementById("css_cityContainer")){
				updateError('isCity', false);
	  		}
		  		cityValidState=true;
	  	}

	  	return cityValidState;
	}

	function isStateValid() {
	  	let stateValidState = false;
	  	if (showBillingAddressFields){
	  		let selectedStateValue = selectedOptionStatesName;
	  		if (selectedStateValue!==null && selectedStateValue!==''){
	  			document.getElementById("css_paymentErrorMessage_selectState").style.display='none';
				updateError('isState', false);
	  			stateValidState = true;
	  		} else {
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_selectState").style.display='block';
	  			updateError('isState', true);
	  			document.getElementById("css_paymentFormError").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Select state");
	  			stateValidState = false;	  		
	  		}
	  	} else {
	  		document.getElementById("css_paymentErrorMessage_selectState").style.display='none';
  			if (document.getElementById("css_stateContainer")){
				updateError('isState', false);
  			}
  			stateValidState = true;
	  	}
	  	
	  	return stateValidState;
	}

	async function validateZipCodeStates() {

		if (selectedOptionStatesName !== null && selectedOptionStatesName !== undefined && selectedOptionStatesName !== '' && 
			cityInputValue !== undefined && cityInputValue !== '' && cityInputValue !== null &&
			zipInputValue !== undefined && zipInputValue !== '' && zipInputValue !== null) {
            let url = '/wthrest/customer-self-service/validateStateZipcode.rs';
            let payload = {stateCode: selectedOptionStatesName, zipCode: zipInputValue};
			let zipValidZipState;
            const validationOnServer = await fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(validationResponse => validationResponse.json()).then(jsonValidationResponse => {
                if (!jsonValidationResponse.validStateZip) {
                    document.getElementById("css_paymentFormError").style.display='block';

					document.getElementById("css_paymentErrorMessage_validZipState").style.display='block';
					document.getElementById("css_zipContainer").classList.add("has-error");
					document.getElementById("css_paymentFormError").scrollIntoView();
					props.CallTracker("Customer Self Service", "Errors", "Enter valid zip code to matched state entered");
					zipValidZipState=false;
                } else {
					document.getElementById("css_paymentErrorMessage_validZipState").style.display='none';
					document.getElementById("css_zipContainer").classList.remove("has-error");
					zipValidZipState=true;
                }
            });
			return zipValidZipState;
        }

	}

	function isZipValid() {
	  	let zipValidState = false;
	  	if (showBillingAddressFields){
	  		let zipValue = zipInputValue;
	  		let zipRegEx = /^[0-9]{5}$/;
	  		if (zipValue===null||zipValue===''||zipValue.length>30||zipValue.length<2||!zipRegEx.test(zipValue)){	  			
	  			document.getElementById("css_paymentFormError").style.display='block';
	  			document.getElementById("css_paymentErrorMessage_validZip").style.display='block';
				updateError('isZip', true);
	  			document.getElementById("css_paymentFormError").scrollIntoView();
	  			props.CallTracker("Customer Self Service", "Errors", "Enter valid zip code");
	  			zipValidState=false;	  			
	  		} else {	  			
	  			document.getElementById("css_paymentErrorMessage_validZip").style.display='none';
	  			updateError('isZip', false);
	  			zipValidState=true;
	  		}	  		
	  	} else {
	  		if (document.getElementById("css_paymentErrorMessage_validZip")){	  	
		  		document.getElementById("css_paymentErrorMessage_validZip").style.display='none';
	  		}

	  		if(document.getElementById("css_zipContainer")){
				updateError('isZip', false);
	  		}
		  	
			zipValidState=true;
	  		
	  	}

	  	return zipValidState;
	}

	function isPaymentChoiceValid(){
		let paymentChoiceValidState = false;
		let paymentChoiceRemainingValue = document.getElementById("css_remainingBalancePayment").checked;
		let paymentChoiceOtherValue = false;
		if(document.getElementById("css_otherAmountPayment")){
			paymentChoiceOtherValue = document.getElementById("css_otherAmountPayment").checked;
		}
		  
		if(document.getElementById("css_otherAmountPayment")){
			if(paymentChoiceRemainingValue===true || paymentChoiceOtherValue===true){				  
				document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='none';
				updateError('isPaymentChoice', false);
				paymentChoiceValidState = true;
			} else{
				document.getElementById("css_paymentFormError").style.display='block';

				document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='block';
				updateError('isPaymentChoice', true);
				paymentChoiceValidState = false;
			}
		} else{
			if(paymentChoiceRemainingValue===true){
				document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='none';
				updateError('isPaymentChoice', false);
				paymentChoiceValidState = true;
			} else{
				document.getElementById("css_paymentFormError").style.display='block';

				document.getElementById("css_paymentErrorMessage_validPaymentChoice").style.display='block';
				updateError('isPaymentChoice', true);
				paymentChoiceValidState = false;
			}
		}

		return paymentChoiceValidState;
	}

	function isCreditCardHolderValid() {
		let creditCardHolderValidState = false;	  	
		let ccHolderValue = selectedOptionCCName.ccHolderNumber;
		if(ccHolderValue!==null && ccHolderValue!=='' && ccHolderValue !== undefined){
			document.getElementById("css_paymentErrorMessage_selectCreditCardHolder").style.display='none';
			updateError('isCreditCardHolder', false);
			creditCardHolderValidState = true;
		} else{
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_selectCreditCardHolder").style.display='block';
			updateError('isCreditCardHolder', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Select credit card holder");
			creditCardHolderValidState = false;	  		
		}
		
		return creditCardHolderValidState;
	}

	function isBillingAddressValid() {
		let billingAddressValidState = false;
		if(showBillingAddressDrop){
			let billingAddressValue = selectedOptionBillingAddress.addressNumber;
			if (billingAddressValue!==null && billingAddressValue!=='' && billingAddressValue !== undefined){
				document.getElementById("css_paymentErrorMessage_selectBillingAddress").style.display='none';
				updateError('isBillingAddress', false);
				billingAddressValidState = true;
			} else{
				document.getElementById("css_paymentFormError").style.display='block';
				document.getElementById("css_paymentErrorMessage_selectBillingAddress").style.display='block';
				updateError('isBillingAddress', true);
				document.getElementById("css_paymentFormError").scrollIntoView();
				props.CallTracker("Customer Self Service", "Errors", "Select billing address");
				billingAddressValidState = false;	  		
			}
		}
		
		return billingAddressValidState;
	}

	function isCcNumberValid() {
		let ccNumberValidState = false;
		
		let ccNumValue = document.getElementById("token").value;
		if (ccNumValue===null||ccNumValue===''||!isAnyCard(ccNumValue)){	  			
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_validcreditcardnumber").style.display='block';
			updateError('isCcNumber', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Enter valid credit card number");
			ccNumberValidState=false;	  			
		} else{	  			
			document.getElementById("css_paymentErrorMessage_validcreditcardnumber").style.display='none';
			updateError('isCcNumber', false);
			ccNumberValidState=true;
		}	  
		
		return ccNumberValidState;
	}

	function isCcvValid() {
		let ccvValidState = false;
		let ccvValue = document.getElementById("css_cccvv").value;
		let ccvRegEx = /^[0-9]{3,4}$/;
		if (ccvValue===null||ccvValue===''){	  			
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_requiredcccvv").style.display='block';
			document.getElementById("css_paymentErrorMessage_validcccvv").style.display='none';
			updateError('isCvv', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Enter valid CVV number");
			ccvValidState=false;	  	
			
		} else if (!ccvRegEx.test(ccvValue)){	  			
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_requiredcccvv").style.display='none';
			document.getElementById("css_paymentErrorMessage_validcccvv").style.display='block';
			updateError('isCvv', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Enter CVV number");
			ccvValidState=false;	  			
		} else {	  			
			document.getElementById("css_paymentErrorMessage_requiredcccvv").style.display='none';
			document.getElementById("css_paymentErrorMessage_validcccvv").style.display='none';
			updateError('isCvv', false);
			ccvValidState=true;
		}	  	  	

		return ccvValidState;
	}

	function isExpirationDateValid() {
		let expirationDateValidState = false;
		let month = selectedOptionExpMonth;
		let year = selectedOptionExpYear;
		if (month === null || month === "" || year === null || year === "" || isExpDateFail(month,year)===true){
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_selectExpDate").style.display='block';
			updateError('isCCExpYear', true);
			updateError('isCCExpMonth', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Select expiration year");
			props.CallTracker("Customer Self Service", "Errors", "Select expiration month");
			expirationDateValidState=false;
		} else if (isExpDateWithin5Days(month,year)===true){
			document.getElementById("css_paymentFormError").style.display='block';
			document.getElementById("css_paymentErrorMessage_5dayExpDate").style.display='block';
			updateError('isCCExpYear', true);
			updateError('isCCExpMonth', true);
			document.getElementById("css_paymentFormError").scrollIntoView();
			props.CallTracker("Customer Self Service", "Errors", "Select expiration year");
			props.CallTracker("Customer Self Service", "Errors", "Select expiration month");
			expirationDateValidState=false;
		} else {
			document.getElementById("css_paymentErrorMessage_selectExpDate").style.display='none';
			document.getElementById("css_paymentErrorMessage_5dayExpDate").style.display='none';
			updateError('isCCExpYear', false);
			updateError('isCCExpMonth', false);
			expirationDateValidState=true;
		}
			
		return expirationDateValidState;
	}

	async function paymentFormIsValid() {
		let zipStateValid = false;
		let paymentFormState = false;
		let insuranceChoiceValid = isInsuranceChoiceValid();
		let paymentAmountValid = isPaymentAmountValid();
		let address1Valid = isAddress1Valid();
		let address2Valid = isAddress2Valid();
		let cityValid = isCityValid();
		let stateValid = isStateValid();
		let zipValid = isZipValid();
		if (showBillingAddressFields) {
			zipStateValid = await validateZipCodeStates();
		}
	  	let creditCardHolderValid = isCreditCardHolderValid();
	  	let billingAddressValid = isBillingAddressValid();
	  	let ccNumberValid = isCcNumberValid();
	  	let expirationDateValid = isExpirationDateValid();
	  	let ccvValid = isCcvValid();
	  	let paymentChoiceValid = isPaymentChoiceValid();
	  	
		if (showBillingAddressFields) {
			paymentFormState = zipStateValid && insuranceChoiceValid && paymentAmountValid && address1Valid && address2Valid && cityValid && stateValid && zipValid && creditCardHolderValid && billingAddressValid && ccNumberValid && ccvValid && expirationDateValid && paymentChoiceValid;
		} else {
			paymentFormState = insuranceChoiceValid && paymentAmountValid && address1Valid && address2Valid && cityValid && stateValid && zipValid && creditCardHolderValid && billingAddressValid && ccNumberValid && ccvValid && expirationDateValid && paymentChoiceValid;
		}
	  	return paymentFormState;
	  	
	}
	
	  function getCookie(cname){
    	  let name = cname + "=";
    	  let decodedCookie = decodeURIComponent(document.cookie);
    	  let ca = decodedCookie.split(';');
    	  for(let i = 0; i <ca.length; i++) {
    	    let c = ca[i];
    	    while (c.charAt(0) === ' ') {
    	      c = c.substring(1);
    	    }
    	    if (c.indexOf(name) === 0) {
    	      return c.substring(name.length, c.length);
    	    }
    	  }
    	  return "";
    	}
    

	async function paymentFormValidationSubmit() {
		const isPaymentFormValid = await paymentFormIsValid();
		if(isPaymentFormValid){	
			document.getElementById("css_paymentFormError").style.display='none';
			document.getElementById("css_tripTools").style.paddingBottom='1.5rem';
		
			if(showBillingAddressFields) {
				dispatch(cssAddress1Update(document.getElementById("css_address1").value));
				dispatch(cssAddress2Update(document.getElementById("css_address2").value));
				dispatch(cssCityUpdate(cityInputValue));
				dispatch(cssPaymentStateUpdate(selectedOptionStatesName));
				dispatch(cssZipUpdate(zipInputValue));
			}

			dispatch(ccMonthUpdate(selectedOptionExpMonth));
			dispatch(ccYearUpdate(selectedOptionExpYear));
			console.debug('Validate payment...');	
			
			let quotedInsuranceAvailable = 0;			  
			if(!props.updateBooking.hasOwnProperty('insuranceQuote')){
				quotedInsuranceAvailable = 0;
			} else{
				quotedInsuranceAvailable = props.updateBooking.insuranceQuote.priceAmount;
			}
			if(css_ins==='N'||(quotedInsuranceAvailable===0||quotedInsuranceAvailable===''||quotedInsuranceAvailable===null)) {
				quotedInsuranceAvailable = 0;
			}
			let validate_todaysPayment = paymentAmount - quotedInsuranceAvailable;
			let url = '/wthrest/customer-self-service/confirmPayment.rs';
			let payload = {
				"bookingNumber": props.updateBooking.bookingNumber,
				"paymentAmount" : validate_todaysPayment,
				"sessionId" : getCookie("WDVID")
			};
			ajaxSpinnerShow();
			fetch(url, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(payload)
			}).then(jsonPaymentConfirmResponse => jsonPaymentConfirmResponse.json()).then(jsonPaymentConfirmResponse => {
				if(jsonPaymentConfirmResponse===''||jsonPaymentConfirmResponse===null) {
					ajaxSpinnerHide();
					dispatch(message6DisplayPropertyDisplay());

				} else {  
					dispatch(message6DisplayPropertyHide());
					dispatch(confirmViewUpdate(jsonPaymentConfirmResponse));
					dispatch(confirmViewFuturePaymentsUpdate(jsonPaymentConfirmResponse.futurePayments));
					dispatch(confirmViewRemainingBalanceUpdate(jsonPaymentConfirmResponse.remainingBalance));
					if(jsonPaymentConfirmResponse.futurePayments!==null && jsonPaymentConfirmResponse.futurePayments!==''){			        		
						//success			        		
						localStorage.setItem("scheduledPaymentHasChanged", false);
						Object.keys(jsonPaymentConfirmResponse.futurePayments).forEach(function(key){
							let parsedCurrentAmount = Number(jsonPaymentConfirmResponse.futurePayments[key].currentAmount);
							let parsedNewAmount = Number(jsonPaymentConfirmResponse.futurePayments[key].newAmount);			        			
							if(parsedCurrentAmount > parsedNewAmount) {							
								dispatch(scheduledPaymentHasChangedTrue());
								localStorage.setItem("scheduledPaymentHasChanged", true);									
							}	
							
						});

					}
					
					if(scheduledPaymentHasChanged === true){
						props.CallTracker("Customer Self Service", "Page Alert", "Please Note: Your payment will reduce a previously scheduled payment, as reflected in the New Summary of Charges above.");
					}
					//open popup
					ajaxSpinnerHide();
					props.CallTracker("Customer Self Service", "OpenPopup", "Payment Confirmation Overlay");
					document.getElementById("openValidatePaymentPop").click();
							
					const upliftEl = document.getElementById('up-pay-monthly-payment');
					const monthlyPayment = upliftEl ? upliftEl.checked : false;

					// props.onChangeView('paymentconfirmation', props.booking, props.booking.hash, props.updateBooking);

					if(document.querySelector("#popup-root") && !monthlyPayment){
						document.getElementsByTagName('body')[0].style = 'overflow-y: hidden';	
						document.querySelector("#css_confirmPaymentButton").scrollIntoView();
						setTimeout(function(){
							const observer = new MutationObserver(function(mutations_list) {
								mutations_list.forEach(function(mutation) {
									mutation.removedNodes.forEach(function(removed_node) {
										document.getElementsByTagName('body')[0].style = 'overflow-y: auto';	
										observer.disconnect();
										
									});
								});
							});

							observer.observe(document.querySelector("#popup-root"), { subtree: false, childList: true });				  			
						
						}, 2000); 
					}
					
					
					
				}
				
			}).catch(error => {
				ajaxSpinnerHide();
				dispatch(message6DisplayPropertyDisplay());
			});       
		}
	}
	function updateCreditCardTypeIcon(e) {
		if (isNaN(e.target.value)) {
			e.target.value = e.target.value.replace(/[^0-9]/g, '');
		}
		else {
			let creditCardNumber = e.target.value.replace(/[^0-9]/g, '');
			if (creditCardNumber.length > 16) {
				creditCardNumber = creditCardNumber.slice(0, 16);
			}
			const cardTypeVisa = document.getElementById('visaIcon');
			const cardTypeMaster = document.getElementById('mastercardIcon');
			const cardTypeDiscover = document.getElementById('discoverIcon');
			const cardTypeAmex = document.getElementById('amexIcon');

			if (creditCardNumber.length < 4) {
				// Reset: display all credit card icons as unselected color
				resetCardTypeSelection();

			} else {
				if (/^4/.test(creditCardNumber)) {
					// Activate Visa Card
					cardTypeVisa.style.display = "block";
					cardTypeVisa.style.color = "#32CD32";

					// Deactivate the rest
					cardTypeMaster.style.display = "none";
					cardTypeDiscover.style.display = "none";
					cardTypeAmex.style.display = "none";


				} else if (/^2[2-7]/.test(creditCardNumber) || /^5[1-5]/.test(creditCardNumber)) {
					// Activate Master Card
					cardTypeMaster.style.display = "block";
					cardTypeMaster.style.color = "#32CD32";

					// Deactivate the rest
					cardTypeVisa.style.display = "none";
					cardTypeDiscover.style.display = "none";
					cardTypeAmex.style.display = "none";

				} else if (/^3[47]/.test(creditCardNumber)) {
					// Activate American Express Card
					cardTypeAmex.style.display = "block";
					cardTypeAmex.style.color = "#32CD32";

					// Deactivate the rest
					cardTypeVisa.style.display = "none";
					cardTypeMaster.style.display = "none";
					cardTypeDiscover.style.display = "none";


				} else if (/^6011/.test(creditCardNumber) || /^644/.test(creditCardNumber) || /^65/.test(creditCardNumber)) {
					// Activate Discover Card
					cardTypeDiscover.style.display = "block";
					cardTypeDiscover.style.color = "#32CD32";

					// Deactivate the rest
					cardTypeVisa.style.display = "none";
					cardTypeMaster.style.display = "none";
					cardTypeAmex.style.display = "none";

				} else {
					// Reset: display all credit card icons as unselected color
					resetCardTypeSelection()
				}
			}
			e.target.value = creditCardNumber;
		}
	}


	function resetCardTypeSelection() {
		const cardTypeVisa = document.getElementById('visaIcon');
		const cardTypeMaster = document.getElementById('mastercardIcon');
		const cardTypeDiscover = document.getElementById('discoverIcon');
		const cardTypeAmex = document.getElementById('amexIcon');

		cardTypeVisa.style.display = "block";
		cardTypeMaster.style.display = "block";
		cardTypeDiscover.style.display = "block";
		cardTypeAmex.style.display = "block";
		cardTypeVisa.style.color = "#333";
		cardTypeMaster.style.color = "#333";
		cardTypeDiscover.style.color = "#333";
		cardTypeAmex.style.color = "#333";
	}

	  	function closeVerificationPopup(){
	  		document.getElementById("closeValidatePaymentPop").click();
	  	}
		function paymentFormSubmit() {

			//document.querySelector("#css_paymentFormError").style.display="none";
			console.debug('Submit payment...');
			
			const upliftEl = document.getElementById('up-pay-monthly-payment');
			const monthlyPayment = upliftEl ? upliftEl.checked : false;
			
			let url = '/wthrest/customer-self-service/makePayment.rs';
		    let payload = {
		        "bookingNumber": props.updateBooking.bookingNumber,
		        "css_ins" : css_ins,
		        "paymentOption" : paymentOption,
		        "paymentOther" : paymentOther,
		        "customerNumber" :  selectedOptionCCName.ccHolderNumber,
		        "otherFirstName" : '',
		        "otherMI" : '',
		        "otherLastName" : '',
		        "token" : document.getElementById("token").value,
		        "ccMonth" : ccMonth,
		        "ccYear" : ccYear,
		        "customerAddressNumber" : selectedOptionBillingAddress.addressNumber,
		        "css_address1" : css_address1,
		        "css_address2" : css_address2,
		        "css_city" : css_city,
		        "css_paymentState" : css_paymentState,
		        "css_zip" : css_zip,
		        "paymentAmount" : paymentAmount,
		        "cvv" : document.getElementById("css_cccvv").value,
		        "sessionId" : getCookie("WDVID"),
				"monthlyPayment" : monthlyPayment
		    };
		    ajaxSpinnerShow();
		    fetch(url, {
		        method: 'POST',
		        headers: {
		            'Accept': 'application/json',
		            'Content-Type': 'application/json'
		        },
		        body: JSON.stringify(payload)
		    }).then(jsonPaymentSubmitResponse => jsonPaymentSubmitResponse.json()).then(jsonPaymentSubmitResponse => {
		    	if(jsonPaymentSubmitResponse===''||jsonPaymentSubmitResponse===null) {
		    		ajaxSpinnerHide();
		    		document.getElementById("closeValidatePaymentPop").click();
		            dispatch(message6DisplayPropertyDisplay());
		        } else { 
					//success
	        		dispatch(message6DisplayPropertyHide());
	        		props.CallTracker("Customer Self Service", "Submit Payment", "Payment Confirmation Overlay");
	    			props.CallTracker("Customer Self Service", "Payment Amount", paymentOption);
	    			if (css_ins === 'Y'){
	    				props.CallTracker("Customer Self Service", "Insurance Purchase", "Post Booking");
	    			}
	    			ajaxSpinnerHide();
	    			props.onChangeViewConfirm(props.booking, jsonPaymentSubmitResponse);
					
		        }
		    }).catch(error => {
		    	ajaxSpinnerHide();
		    	document.getElementById("closeValidatePaymentPop").click();
		    	dispatch(message6DisplayPropertyDisplay());
		    	props.CallTracker("Customer Self Service", "Errors", "Payment Submission Failed");
		    });       
		}
		const ControlledRefPopup = () => {
			window.dataLayer = window.dataLayer || [];	        
			  const ref = useRef();
			  const openTooltip = () => ref.current.open();
			  const closeTooltip = () => {ref.current.close();document.getElementsByTagName('body')[0].style = 'overflow-y: auto';}
			  const toggleTooltip = () => ref.current.toggle();
			  return (
			    <div>
			      <button type="button" className="button visuallyhidden" id="openValidatePaymentPop" onClick={openTooltip}>
			        open
			      </button>
			      <button type="button" className="button visuallyhidden" id="closeValidatePaymentPop" onClick={closeTooltip}>
			        close
			      </button>

			      <button type="button" className="button visuallyhidden" onClick={toggleTooltip}>
			        toggle
			      </button>
			      <Popup
			        ref={ref}
			        trigger={
			          <button type="button" className="button visuallyhidden" tabindex={-1}>
			            I am the trigger
			          </button>
			        } modal
			      >
			        <div className="paymentVerificationModal">
			        <div id="paymentVerification">
			    	<div id="paymentVerificationPopup" tabindex="-1" aria-hidden="true" aria-labelledby="paymentVerificationHeader" >
			    	   	<a id="paymentVerificationClose" href="# " class="ui-btn ui-corner-all ui-icon-delete ui-btn-icon-notext ui-btn-right wth2-popupCloseFunction" role="button" onClick={e =>{e.preventDefault();closeVerificationPopup()}} title="Close"> </a> 
			    	    <h5 id="paymentVerificationHeader" class="wth2-simplePopupHeader wth2_css_paymentVerificationHeader">Payment Confirmation</h5>
			    	    <div id="css_paymentVerificationDescription" class="wth2-paymentVerificationDescription">Please review your Summary of Charges and confirm today&#39;s payment below.</div>
			    	    <p id="paymentVerificationContent" class="wth2-simplePopupContent wth2-popupDatesContent">	
			    		<form name="css_paymentVerification" id="css_paymentVerification" novalidate>			
			    			<div class="wth2-paymentVerificationSOC">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold wth2-css_paymentVerificationSOCNewHeader" id="css_paymentVerificationSOCNewHeader">Summary of Charges</div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotal">Total</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCTotalContent"><NumberFormat value={totalcost} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCInsurancel">Travel Insurance</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCInsuranceContent">
			    	    			{css_ins==='Y' &&
			    	    				<span>Payment Required</span>
									}
			    	    			{(css_ins==='N' || css_ins==='' || css_ins===null) &&
			    	    			<span>{insuranceStatus}</span>
									}
			    	    		</div>
			    	    		{css_ins==='Y' &&
			    	    			<div class="wth2-paymentVerificationLine4 wth2-paymentVerification_insAddition" >Adding LeisureCare for <NumberFormat value={props.updateBooking.insuranceQuote.priceAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		}
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotalPrevious">Previous Payments</div>
			    	    		{props.updateBooking.bookingSummary.charges.paymentsToDate!==0 &&
			    	    			<div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCPreviousContent">- <NumberFormat value={props.updateBooking.bookingSummary.charges.paymentsToDate} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		}
			    	    		{props.updateBooking.bookingSummary.charges.paymentsToDate===0 &&
			    	    		<div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCPreviousContent">$0.00</div>
			    	    		}
			    	    		<div class="wth2-paymentVerificationLine wth2-bold" id="css_paymentVerification_SOCTotalNew">Today&#39;s Payment</div><div class="wth2-paymentVerificationLine2" id="css_paymentVerification_SOCNewContent">- <NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></div>
			    	    		<div class="wth2-paymentVerificationLine wth2-bold wth2-paymentVerificationRemBalLine" id="css_paymentVerification_SOCTotalRemaining">Remaining Balance</div>
			    	    		<div class="wth2-paymentVerificationLine2 wth2-paymentVerificationRemBalLine" id="css_paymentVerification_SOCRemainingContent">
			    	    			{confirmViewRemainingBalance===0 &&
			    	    			<span>Paid in Full</span>
			    	    			}
			    	    			{confirmViewRemainingBalance>0 &&
			    	    			<span><NumberFormat value={confirmViewRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span>
			    	    			}
			    	    		</div>
			    	    		{//eslint-disable-next-line
									confirmViewFuturePayments!=null && confirmViewFuturePayments!='' &&
			    	    		<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerification_SOCTotalScheduled">Scheduled Payments</div>
			    	    		}
			    	    		{confirmViewFuturePayments!==null && confirmViewFuturePayments!=='' &&
			    	    		<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_FPcontainer" id="css_paymentVerification_SOCTotalScheduledContent">
			    	    			{confirmViewFuturePayments.map((newfuturepayments, index, arr)=>(
			    	    				<div id={"css_newFuturePay_" + index + "_line"}>
			    							{parseFloat(newfuturepayments.currentAmount) > parseFloat(newfuturepayments.newAmount) &&
			    							<div>
			    								<span id={"css_newFuturePay_" + index + "_pricecurrent"} class="wth2-newFuturePay_oldSCPrice"><NumberFormat value={newfuturepayments.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> <span id={"css_newFuturePay_" + index + "_Now"} class="wth2-bold wth2-headerH5">Now <span id={"css_newFuturePay_" + index + "_pricenew"}><NumberFormat value={newfuturepayments.newAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span></span> on <span className="wth3-futurePayCCType" id={"css_newFuturePay_" + index + "_cctype"}>{newfuturepayments.creditCardType.replace("(R)", " \u00AE ").toLowerCase()}</span> ending in <span id={"css_newFuturePay_" + index + "_ccnumber"}>{newfuturepayments.maskedCreditCardNumber.slice(-4)}</span> on {newfuturepayments.withinFiveDays===false &&<span id={"css_newFuturePay_" + index + "_date"}>{newfuturepayments.futurePaymentDate}</span>}{newfuturepayments.withinFiveDays===true && newfuturepayments.newAmount!=='0' && <span id={"css_newFuturePay_" + index + "_date"} class="wth2-css_dateHighlightFP">{newfuturepayments.futurePaymentDate} - Payment will process soon.</span>}				
			    							</div>
			    							}
			    							{parseFloat(newfuturepayments.currentAmount) === parseFloat(newfuturepayments.newAmount) &&
			    							<div>
			    								<span id={"css_newFuturePay_" + index + "_pricecurrent"}><NumberFormat value={newfuturepayments.currentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> on <span className="wth3-futurePayCCType" id={"css_newFuturePay_" + index + "_cctype"}>{newfuturepayments.creditCardType.replace("(R)", " \u00AE ").toLowerCase()}</span> ending in <span id={"css_newFuturePay_" + index + "_ccnumber"}>{newfuturepayments.maskedCreditCardNumber.slice(-4)}</span> on {newfuturepayments.withinFiveDays===false &&<span id={"css_newFuturePay_" + index + "_date"}>{newfuturepayments.futurePaymentDate}</span>}{newfuturepayments.withinFiveDays===true &&<span class="wth2-css_dateHighlightFP">{newfuturepayments.futurePaymentDate} - Payment will process soon.</span>}				
			    							</div>
			    							}
			    						</div>
			    	    			))}
			    	    			
			    				</div>
			    	    		}
			    	    		{confirmViewFuturePayments!==null && confirmViewFuturePayments!==''&&scheduledPaymentHasChanged===true &&
			    				<div id="scheduledPaymentChangesWiseMessageWraper" class="scheduledPaymentChangesWiseMessageWraper wth2-warningMessage" aria-hidden="true">
			    					<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
			    					<div id="scheduledPaymentChangesWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
			    					<div id="scheduledPaymentChangesWiseMessageText">Your payment will reduce a previously scheduled payment, as reflected in the New Summary of Charges above.</div>		
			    				</div>
			    	    		}
			    	    	</div>
			    			<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_paymentNewHeader wth2-bold">Today's Payment Information</div>
			    			<div class="wth2-paymentVerification_ccHolderContainer">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerification_CCHolder">Credit Card Holder:</div>
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_CCHolder_Content">{ccHolderForVerificationName}</div>
			    				{ccBillingAddressForVerification!=='new' && ccBillingAddressForVerification!=='choose' &&
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_Billing_Content">{ccBillingAddressForVerification}</div>
								}
								{ccBillingAddressForVerification==='new' &&
			    				<div class="wth2-paymentVerificationLine3" id="css_css_paymentVerification_Billing_Content">{css_address1} {css_address2} {css_city}, {css_paymentState} {css_zip}</div>
								}
			    			</div>			
			    			<div class="wth2-paymentVerification_ccPaymentContainer">
			    				<div class="wth2-paymentVerificationLine3 wth2-bold" id="css_paymentVerificationPaymentTitle">Payment:</div>
			    				<div class="wth2-paymentVerificationLine3" id="css_paymentVerification_Information"><span id="css_css_paymentVerification_paymentAmountCC"><NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span> will be charged to your credit card **** which expires on <span id="css_css_paymentVerification_ExpDate_Content">{ccMonth}/{ccYear}</span></div>
			    			</div>
			    	    	<div class="wth2-paymentVerificationLine3 wth2-paymentVerification_terms" id="css_paymentVerification_Terms">By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of this fare. I also understand that cancellation fees may apply.</div>
			    			<div class="wth_css_popButtons btn-wrapper">
			    				<button id="css_NoPaymentButton" class="ui-btn ui-btn-inline ui-shadow ui-corner-all ui-mini wth3-paymentCancel" onClick={() => {closeVerificationPopup()}}>Cancel</button>
			    				<button id="css_confirmPaymentButton" class="primary-btn" onClick={e=> {e.preventDefault();paymentFormSubmit()}}>Confirm <NumberFormat value={paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> Payment</button>
			    			</div>	
			    	    	
			    	    </form>
			    	    </p>
			    	</div>
			    </div>
			        </div>
			      </Popup>
			    </div>
			  );
			};

    return <div id='paymentPageMain' className='wth3-cssMainContent'>
		<div className='wth3-cssMainContent__leftCont'>
			{Tooltip3}
			{ControlledRefPopup()}
			<div id="mainContent" className='wth3-cssMainContent__leftCont-topContent' tabindex="-1">
				
				<button class="wth3-returnButton" id="css_tripTools" onClick={e => {e.preventDefault(); checkInsurance()} }>
					<i class="fas fa-home" aria-hidden='true'></i>Return to Booking Summary
				</button>

				<div className={`wth3-cssMainContent__leftCont-topContent-pageTitleCont ${props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!=='' ? '' : 'wth3-styleWithoutInsurPageTitleCont'}`}>
					<h1 id='css_title_visible' className={`wth3-cssMainContent__leftCont-topContent-pageTitleCont-text ${props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!=='' ? '' : 'wth3-styleWithOutInsurPageTitle'} ${(remainingBalance <= 25 || props.updateBooking.makePayment.remainingBalance <= 25) ? 'wth3-addBorderStyle' : ''}`}>Make A Payment</h1>
				</div>
				
				{((remainingBalance <= 25 || props.updateBooking.makePayment.remainingBalance <= 25) && remainingBalance !== 0) && props.updateBooking.bookingSummary.charges.insurance.include &&
					<div id="lessThan25MessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg lessThan25MessageWraper wth2-informationMessage wth3-display-desktop" aria-hidden="true">
						<i class="fa fa-info-circle" aria-hidden="true"></i>
						<div id="lessThan25WiseMessageHeader" class="wth2-informationMessageHeader">Please Note:</div>
						<div id="lessThan25WiseMessageText">Balances below $25.00 cannot be paid online. To complete your payment, please call us at {charges.cruisePhone}.</div>		
					</div>						
				}

				{charges.pageId === 'payment' && charges.futurePaymentsRemoved === true && !charges.bookingPastDue && charges.paymentDue !== "" && charges.payRemainingBalance <= 25 &&
                	<div id="scheduledPaymentWiseMessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg wth2-warningMessage wth3-display-desktop" aria-hidden="true">
						<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
						<div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
						<div id="scheduledPaymentWiseMessageText">Some payments that are scheduled to be paid in the next 5 days may not be paid online now.</div>		
					</div>						
				}
				
				<div id="message6" class="wth2-errorMessage wth2-errorMessageHeader" style={message6DisplayProperty}>
					<i class="fa fa-exclamation-circle" aria-hidden="true"></i> We are experiencing technical difficulties. Please try your request in 20 minutes. Please call {props.siteConfigData.cruisePhone} to speak to a customer service agent for information about your trip. Customer service agents are available {props.siteConfigData.operationHrs}.
				</div>
				
				<div id="css_paymentFormError" class="wth2-errorMessage" style={{display:'none'}}>
					<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
					<div class="wth2-errorMessageHeader" id="css_paymentErrorHeader"> Please complete the required fields.</div>
					<ul>
						<li id="css_paymentErrorMessage_selectInsurance" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_yes_insurance')}>Select an option for Travel Insurance</a>
						</li>
						<li id="css_paymentErrorMessage_validPaymentAmount" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'otherAmountPaymentInputField')}>Enter valid payment amount</a>  
						</li>
						<li id="css_paymentErrorMessage_validPaymentChoice" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_remainingBalancePayment')}>Choose a payment amount</a> 
						</li>
						<li id="css_paymentErrorMessage_validPaymentAmountTooMuch" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'otherAmountPaymentInputField')}>Enter payment amount equal to or less than <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></a>   
						</li>
						<li id="css_paymentErrorMessage_validPaymentAmountTooLittle" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'otherAmountPaymentInputField')}>Enter payment amount of <NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> or greater</a>
						</li>										
						<li id="css_paymentErrorMessage_validStreetAddress1" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_address1')}>Enter valid street address 1</a>
						</li>
						<li id="css_paymentErrorMessage_validStreetAddress2" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_address2')}>Enter valid street address 2</a>
						</li>
						<li id="css_paymentErrorMessage_validCity" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_city')}>Enter valid city</a>
						</li>
						<li id="css_paymentErrorMessage_selectState" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_stateContainer')}>Select state</a>
						</li>
						<li id="css_paymentErrorMessage_validZip" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_zip')}>Enter valid 5-digit U.S. Zip Code</a>
						</li>
						<li id="css_paymentErrorMessage_validZipState" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_zip')}>Enter valid 5-digit U.S. Zip Code to match State entered</a>
						</li>
						<li id="css_paymentErrorMessage_selectCreditCardHolder" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_ccHolderContainer')}>Select credit card holder</a>
						</li>
						<li id="css_paymentErrorMessage_selectBillingAddress" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_BillingAddressDrop')}>Select billing address</a> 
						</li>
						<li id="css_paymentErrorMessage_validcreditcardnumber" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'token')}>Enter valid credit card number</a>
						</li>	
						<li id="css_paymentErrorMessage_validcccvv" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_cccvv')}>Enter valid CVV number</a>
						</li>
						<li id="css_paymentErrorMessage_requiredcccvv" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_cccvv')}>Enter a CVV number</a>
						</li>
						<li id="css_paymentErrorMessage_selectExpDate" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'css_ccExpMonthContainer')}>Select expiration date</a>
						</li>
						<li id="css_paymentErrorMessage_5dayExpDate" class="wth2-formErrorMessage" style={{display:'none'}}>
							<a href='# ' onClick={(e) => errorHandeScrollInto(e, 'token')}>Your card will expire within 5 days. Please use another card or call {props.siteConfigData.cruisePhone} to make a payment.</a>
						</li>
					</ul>
				</div>
				

				<SummaryChargesMobile toggleExpand={toggleExpand} handleKeyDownSummaryCharges={handleKeyDownSummaryCharges} charges={charges} isExpanded={isExpanded} contentId={contentId} isMobileOrDesktop={isMobileOrDesktop} />
				
				{(remainingBalance <= 25 || props.updateBooking.makePayment.remainingBalance <= 25) && remainingBalance !== 0 && props.updateBooking.bookingSummary.charges.insurance.include &&
					<div id="lessThan25MessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg lessThan25MessageWraper wth2-informationMessage wth3-display-mobile" aria-hidden="true">
						<i class="fa fa-info-circle" aria-hidden="true"></i>
						<div id="lessThan25WiseMessageHeader" class="wth2-informationMessageHeader">Please Note:</div>
						<div id="lessThan25WiseMessageText">Balances below $25.00 cannot be paid online. To complete your payment, please call us at {charges.cruisePhone}.</div>		
					</div>						
				}

				{charges.pageId === 'payment' && charges.futurePaymentsRemoved === true && !charges.bookingPastDue && charges.paymentDue !== "" && charges.payRemainingBalance <= 25 &&
                	<div id="scheduledPaymentWiseMessageWraper" class="wth3-summaryCharges__bottom-scheduledPaymentWiseMsg wth2-warningMessage wth3-display-mobile" aria-hidden="true">
						<i class="fa fa-exclamation-circle " aria-hidden="true"></i>
						<div id="scheduledPaymentWiseMessageHeader" class="wth2-warningMessageHeader">Please Note:</div>
						<div id="scheduledPaymentWiseMessageText">Some payments that are scheduled to be paid in the next 5 days may not be paid online now.</div>		
					</div>						
				}
			</div>

			{/* Form */}
			<div id="css_payment_FormContainer" className='wth3-formContainer'>
				<form name="css_payment" id="css_payment" novalidate>
					<input type="hidden" value={props.updateBooking.bookingNumber} name="bookingNumber"/>
					
					{/* START: LEISURECASE TRAVEL INSURANCE */}
					{props.updateBooking.bookingSummary.quoteInsuranceInd==='Y' && props.updateBooking.insuranceQuote.priceAmount!=='' &&
					<div class="wth3-cssMainContainer leisurecareContainer">
						<div class="wth3-cssMainContainer__headContainer">
							<span id="css_liesureCare" class="wth3-cssMainContainer__headContainer-headDesc">
								<i class="fa fa-shield" aria-hidden="true"></i> LeisureCare Travel Insurance (Recommended):
							</span>
						</div>
						<div id="css_insuranceText2" class="wth3-cssMainContainer__insuranceText2Container">
							<div id="css_insuranceLifetime" class="wth3-cssMainContainer__insuranceText2Container-headDesc1">You've planned the cruise of a lifetime. Now plan ahead for life's uncertainties.</div>
							<div class="wth3-cssMainContainer__insuranceText2Container-headDesc2">Add LeisureCare Travel Insurance to your booking for coverage of:</div>
						</div>
						
						<div class="wth3-cssMainContainer__insuranceCoverageContainer">
							<div id="css_insuranceBullet1" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to 100% of your trip cost if you need to <span class="wth2-bold"> cancel </span>due to illness, injury or other covered reasons</span>
							</div>
							<div id="css_insuranceBullet2" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to 100% of your trip cost if you need to <span class="wth2-bold">start late or come home early</span> due to illness, injury or other covered reasons</span>
							</div>
							<div id="css_insuranceBullet3" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $1,000 for covered <span class="wth2-bold">trip delays</span></span>
							</div>
							<div id="css_insuranceBullet4" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $1,000 for <span class="wth2-bold">missed flight connections</span></span>
							</div>	
							<div id="css_insuranceBullet5" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $1,500 for <span class="wth2-bold">lost, stolen or damaged baggage</span></span>
							</div>	
							<div id="css_insuranceBullet6" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $500 for necessary personal articles if your <span class="wth2-bold">bags are delayed</span></span>
							</div>
							<div id="css_insuranceBullet7" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $50,000 for covered <span class="wth2-bold">medical expenses</span> if you get injured or ill on vacation</span>
							</div>
							<div id="css_insuranceBullet8" class="wth3-cssMainContainer__insuranceCoverageContainer-item">
								<i class="fa fa-check" aria-hidden="true"></i>
								<span>Up to $50,000 for a covered <span class="wth2-bold">emergency medical evacuation</span></span>
							</div>
						</div>	

						<div class="wth3-cssMainContainer__insuranceSelectContainer">
							<div id="css_travelProtectionOptionLabel" class="wth3-cssMainContainer__insuranceSelectContainer-desc">Please select an option:</div>
							<div class="wth3-radioBtn" id="css_insuranceChoice">
								<fieldset class={`wth3-radioBtn__wrapper ${paymentErrors.isInsuranceChoice ? 'has-error' : ''}`}>
									<div id="css_insuranceYes" class="wth3-radioBtn__wrapper-item"
										onClick={() => {changeInsuranceChoice('yes')}}
										onFocus={handleRadioBtnFocus}
										onBlur={(e) => {handleRadioBtnBlur(); removeErrorOutline(e, 'css_insuranceYes');}}
									>
										<input id="css_yes_insurance" type="radio" name="css_ins" value="Y" 
											aria-labelledby='travelInsuranceLabel1 travelInsuranceLabel2'
										/>
										<span onClick={() => {changeInsuranceChoice('yes')}} className={`wth3-radioCircle ${travelInsurance === 'yes' ? 'wth3-radioCircleActive' : ''}`}>
											{travelInsurance === 'yes' && 
												(<SvgCheckmark />)
											}
										</span>
										<div class="wth3-radioBtn__wrapper-item-box">
											<span id='travelInsuranceLabel1' class="wth3-radioBtn__wrapper-item-box-text1">Yes</span>
											<span id='travelInsuranceLabel2' class="wth3-radioBtn__wrapper-item-box-text2">Include LeisureCare Travel Insurance For <span id="css_ins_perpersonnight_price"><NumberFormat value={props.updateBooking.insuranceQuote.priceAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /></span></span>
										</div>
									</div>
									<div id="css_insuranceNo" class="wth3-radioBtn__wrapper-item"
										onClick={() => {changeInsuranceChoice('no')}}
										onFocus={handleRadioBtnFocus}
										onBlur={handleRadioBtnBlur} 
									>
										<input id="css_no_insurance" type="radio" name="css_ins" value="N" 
											aria-labelledby='travelInsuranceNoLabel1 travelInsuranceNoLabel2'
										/>
										<span onClick={() => {changeInsuranceChoice('no')}} className={`wth3-radioCircle ${travelInsurance === 'no' ? 'wth3-radioCircleActive' : ''}`}>
											{travelInsurance === 'no' && 
												(<SvgCheckmark />)
											}
										</span>
										<div class="wth3-radioBtn__wrapper-item-box">
											<span id='travelInsuranceNoLabel1' class="wth3-radioBtn__wrapper-item-box-text1">No, Thank You</span>
											<span id='travelInsuranceNoLabel2' class="wth3-radioBtn__wrapper-item-box-text2">I choose to travel without Insurance</span>
										</div>
									</div>
								</fieldset>	
							</div>
							<div id="css_travelProtectionDisclaimer" class="wth3-cssMainContainer__insuranceSelectContainer-travelProtectionDisclaimer">*Plan cost amounts are subject to change without notice. Don’t Delay, Add LeisureCare Today!</div>
							<div id='cssInsuranceTerm' class="wth3-cssMainContainer__insuranceSelectContainer-insuranceTerms">
								<div id="css_insPDF" class="wth3-cssMainContainer__insuranceSelectContainer-insuranceTerms-insRemainingBalancePDF" >
									<a id="css_insPDFLink" href={props.updateBooking.insuranceQuote.insurancePdf} target="_blank" rel="noopener noreferrer">
										<i class="fa fa-file-pdf-o" aria-hidden="true"></i> View terms, conditions and plan sponsors</a>
								</div>
								<div id="message8" aria-live='polite' class="wth2-warningMessage" style={message8DisplayProperty}>
									<span class="wth2-warningMessageHeader"><i class="fa fa-exclamation-circle" aria-hidden="true"></i>Please Note:</span><br/>
									{message8HelpVal}</div>
							</div>
						</div>
					</div>
					}
					{/* END: LEISURECASE TRAVEL INSURANCE */}		

					{/* START: SELECT A PAYMENT OPTION */}
					{payRemainingBalance>=25 &&
					<div class="wth3-cssMainContainer wth3-selectPayment">
						<div class="wth3-cssMainContainer__headPaymentContainer">
							<span id="css_amountToPayHeader" class="wth3-cssMainContainer__headContainer-headDesc">Select a payment option</span>
						</div>
		
						<div ref={(el) => (inputRefs.current['paymentChoiceContainer'] = el)} class="wth3-radioBtn">
							{remainingBalance<25 &&
								<div>
									<div id="css_paymentDueTooSmall" class="wth2-informationMessage wth2-informationMessageHeader"><i class="fa fa-phone-square" aria-hidden="true"></i> {props.updateBooking.makePayment.message}</div>
								</div>
							}
							<fieldset class={`wth3-radioBtn__wrapper ${paymentErrors.isPaymentChoice ? 'has-error' : ''}`} id="css_paymentChoiceContainer">

								{/* Pay Remaining Balance */}
								{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===false &&
									<div id="cssRemainingBalancePayment" class="wth3-radioBtn__wrapper-item"
										onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}
										onFocus={handleRadioBtnFocus}
										onBlur={(e) => {handleRadioBtnBlur(); removeErrorOutline(e, 'cssRemainingBalancePayment');}}
									>
										<input id="css_remainingBalancePayment" type="radio" name="paymentOption"  value="Full"
											aria-labelledby='payRemainingBalanceLabel1 payRemainingBalanceLabel2 payRemainingBalanceLabel3'
										/>
										
										<span onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}  className={`wth3-radioCircle ${selectedPaymentOption === 'Pay Remaining Balance' ? 'wth3-radioCircleActive' : ''}`}>
											{selectedPaymentOption === 'Pay Remaining Balance' && 
												(<SvgCheckmark />)
											}
										</span>
										<div class="wth3-radioBtn__wrapper-item-box">
											<span id='payRemainingBalanceLabel1' class="wth3-radioBtn__wrapper-item-box-text1">Pay Remaining Balance</span>
											<span id='payRemainingBalanceLabel2' class="wth3-radioBtn__wrapper-item-box-text2">
												<NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
												{paymentDue !== '' && paymentDue !== null && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
													<span> - <span id="css_dueMessage">{paymentDue}</span></span>
												}
											</span>
											<span id='payRemainingBalanceLabel3' className='wth3-radioBtn__wrapper-item-box-chargedText'>You will be charged the full remaining balance</span>
										</div>
										
									</div>
								}

								{/* Pay Remaining Balance */}
								{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===true && 
									<div id="cssRemainingBalancePayment" class={`wth3-radioBtn__wrapper-item ${paymentErrors.isPaymentChoice ? 'has-error' : ''}`}
										onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}
										onFocus={handleRadioBtnFocus}
										onBlur={(e) => {handleRadioBtnBlur(); removeErrorOutline(e, 'cssRemainingBalancePayment');}}
									>
										<input id="css_remainingBalancePayment" type="radio" name="paymentOption"  value="Full"
											aria-labelledby='payRemainingBalanceLabel1 payRemainingBalanceLabel2 payRemainingBalanceLabel3 css_pastDueMessage'
										/>
										<span onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}  className={`wth3-radioCircle ${selectedPaymentOption === 'Pay Remaining Balance' ? 'wth3-radioCircleActive' : ''}`}>
											{selectedPaymentOption === 'Pay Remaining Balance' && 
												(<SvgCheckmark />)
											}
										</span>

										<div class="wth3-radioBtn__wrapper-item-box">
											<span id='payRemainingBalanceLabel1' class="wth3-radioBtn__wrapper-item-box-text1">Pay Remaining Balance</span>
											<span id='payRemainingBalanceLabel2' class="wth3-radioBtn__wrapper-item-box-text2">
												<NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
												{paymentDue !== '' && paymentDue !== null && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
													<span> - <span id="css_dueMessage">{paymentDue}</span></span>
												}
											</span>
											<span id='payRemainingBalanceLabel3' className='wth3-radioBtn__wrapper-item-box-chargedText'>You will be charged the full remaining balance</span>
											{props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' && 
												<span id="css_pastDueMessage" class="wth2-errorMessageHeader">Balance is past due </span>
											}
										</div>
									</div>
								}
								{props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments>=25 && remainingBalance>=25 && bookingPastDue===false && minimumPaymentAmount!==payRemainingBalance && 
									
									<div id="cssOtherAmountPayment" class={`wth3-radioBtn__wrapper-item ${paymentErrors.isPaymentAmount ? 'has-error' : ''}`}
										onClick={(e) => {changePaymentChoiceOther(); focusInput(e, 'customAmount'); setSelectedPaymentOption('Custom Amount')}}
										onFocus={handleRadioBtnFocus}
										onBlur={handleRadioBtnBlur}
									>
										<input id="css_otherAmountPayment" type="radio" name="paymentOption" value="Other"
											aria-labelledby='customAmountPaymentLabel1 customAmountPaymentLabel2'												
										/>

										<span onClick={(e) => {changePaymentChoiceOther(); focusInput(e, 'customAmount'); setSelectedPaymentOption('Custom Amount')}}   className={`wth3-radioCircle ${selectedPaymentOption === 'Custom Amount' ? 'wth3-radioCircleActive' : ''}`}>
											{selectedPaymentOption === 'Custom Amount' && 
												(<SvgCheckmark />)
											}
										</span>

										<div className='wth3-customAmountWrapper'>
											<div className="wth3-inputField" id='customAmountPaymentLabel1' 
												onClick={(e) => focusInput(e, 'customAmount')}
												onKeyDown={() => handleKeyDownInput('customAmount')}
											>
												<InputFieldLabel 									
													id="css_otherAmountPaymentLabel" 
													label='Pay Custom Amount'
													htmlFor='otherAmountPaymentInputField'
													className='customAmountLabel'
												/>
												<div className='wth3-inputField__customAmountBox'>
													<span id='cssCustomerAmountMoneySign' className='wth3-inputField__customAmountBox-moneySign'>$</span>
													<InputFieldValue 
														ref={(el) => (inputRefs.current['customAmount'] = el)}
														id="otherAmountPaymentInputField" 
														size="10" 
														name="paymentOther" 
														placeholder='0.00' 
														className="customAmountValue"
														onChange={otherAmountChange} 
														onBlur={(e) => {otherAmountChange();removeErrorOutline(e, 'otherAmountPaymentInputField');}} 
														onClick={clearOtherField}  
													/>
												</div>
											</div>
											<span onClick={(e) => {e.preventDefault(); e.stopPropagation();}}
												id="customAmountPaymentLabel2" 
												class="wth3-customAmountWrapper__wth3-cssHelper">
													Payment must be between <NumberFormat value={minimumPaymentAmount} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} /> and <NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
											</span>
										</div>
									</div>
								}

								{((props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments===0 && remainingBalance>=25 && props.updateBooking.bookingSummary.quoteInsuranceInd==='Y') || (props.updateBooking.bookingSummary.charges.balanceExcludeFuturePayments<25 && css_ins==='Y')) &&
									<div id="cssRemainingBalancePayment" class={`wth3-radioBtn__wrapper-item ${paymentErrors.isPaymentChoice ? 'has-error' : ''}`}
										onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}
										onFocus={handleRadioBtnFocus}
										onBlur={(e) => {handleRadioBtnBlur(); removeErrorOutline(e, 'cssRemainingBalancePayment');}}
									>
										<input id="css_remainingBalancePayment" type="radio" name="paymentOption"  value="Full"
											aria-labelledby='payRemainingBalanceLabel1 payRemainingBalanceLabel2 payRemainingBalanceLabel3'
										/>
										<span onClick={() => {changePaymentChoiceFull(); setSelectedPaymentOption('Pay Remaining Balance');}}  className={`wth3-radioCircle ${selectedPaymentOption === 'Pay Remaining Balance' ? 'wth3-radioCircleActive' : ''}`}>
											{selectedPaymentOption === 'Pay Remaining Balance' && 
												(<SvgCheckmark />)
											}
										</span>

										<div class="wth3-radioBtn__wrapper-item-box">
											<span id='payRemainingBalanceLabel1' class="wth3-radioBtn__wrapper-item-box-text1">Pay Remaining Balance</span>
											<span id='payRemainingBalanceLabel2' class="wth3-radioBtn__wrapper-item-box-text2">
												<NumberFormat value={payRemainingBalance} displayType={'text'} thousandSeparator={true} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />
												{paymentDue !== '' && paymentDue !== null && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking River' && props.updateBooking.bookingOverview.cruise.cruiseLineName !== 'Viking Ocean' &&
													<span> - <span id="css_dueMessage">{paymentDue}</span></span>
												}
											</span>

											
										</div>
									</div>
								}
							</fieldset>	
						</div>
					</div>
					}
					{/* END: SELECT A PAYMENT OPTION */}

					{/* START: BILLING AND PAYMENT INFORMATION */}
					{payRemainingBalance>=25 &&
					<div class="wth3-cssMainContainer wth3-billAndPayment">
						<div class="wth3-cssMainContainer__headContainer wth3-billingDetailsText">
							<span id="css_ccInfoHeader" class="wth3-cssMainContainer__headContainer-headDesc">Billing Details</span>
						</div>

						<div className='wth3-cssMainContainer__billingInfoContainer'>
							{/* START ----------- CREDITCARD HOLDER: INPUT DROPDOWN LIST */}
							<div className='wth3-cssMainContainer__billingInfoContainer-ccHolderWrapper'>
								<div ref={refCCHOlderContainer} id='css_ccHolderContainer' 
									className={`wth3-inputField wth3-focusStylesContainer ${isOpenCCHolder ? 'openDropdownStyles' : ''} ${paymentErrors.isCreditCardHolder ? 'has-error' : ''}`}
									onClick={(e) => toggleDropdown(e, 'css_ccHolderContainer')}
									onKeyDown={(e) => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault();
											toggleDropdown(e, 'css_ccHolderContainer');
										}
									}}
									onBlur={(e) => removeErrorOutline(e, 'css_ccHolderContainer')}
									role='combobox'
									aria-expanded={isOpenCCHolder}
									aria-controls='downdrop-list'
									aria-labelledby='css_ccHolderLabel'
									tabindex={0}
								>
									<InputFieldLabel 									
										id="css_ccHolderLabel" 
										label='Credit Card Holder'
										className='ccHolderLabel'
									/>
									<div className="wth3-inputField__box">
										<span 									
											id="customerNumber" 
											className='wth3-inputField__box-value'
										>{selectedOptionCCName.ccHolderName ? selectedOptionCCName.ccHolderName : 'Select Card Holder'}</span>
									</div>

									<div className='wth3-dropdownIcons'>
										{isOpenCCHolder ?
											(<i class="fas fa-angle-up" aria-hidden='true'></i>) 
											:
											(<i class="fas fa-angle-down" aria-hidden='true'></i>)
									}
										
									</div>
								</div>

								{isOpenCCHolder && (
								<ul id="customerNumberList" className='wth3-cssDropdownList' ref={refCCHolderList} role='listbox' tabIndex={0}
									aria-labelledby='css_ccHolderLabel'
									onKeyDown={handleDropdownKeyDown}
									aria-activedescendant={highlighedIndexCCHolder >= 0 ? props.updateBooking.makePayment.creditCardHolderList[highlighedIndexCCHolder].customerNumber : undefined}
								>
									{props.updateBooking.makePayment.creditCardHolderList.map((guest, index, arr)=>(
									<li key={index} 
									onClick={() => {ccHolderOnChange(guest, index)}}
									role='option'
									aria-selected={selectedOptionCCName.ccHolderName !== undefined && noCase(selectedOptionCCName.ccHolderName) === noCase(guest.firstName) + ' ' + noCase(guest.lastName) ? true : false}
									className={`wth3-cssDropdownList__customerNumberOptionItem ${highlighedIndexCCHolder === index && guest.creditCardHolder  ? 'wth3-focusOutlineLi' : ''} ${selectedOptionCCName.ccHolderName !== undefined && noCase(selectedOptionCCName.ccHolderName) === `${noCase(guest.firstName) + ' ' + noCase(guest.lastName)}` ? 'selectedOptionStyles' : ''} ${!guest.creditCardHolder ? 'wth3-disableItem' : ''}`}
									value={guest.customerNumber} 
									id={"css_paxChoice_" + guest.customerNumber}>{noCase(guest.firstName)} {noCase(guest.lastName)}</li>
									))}
								</ul>
								)}

							</div>
							{/* END ----------- CREDITCARD HOLDER: INPUT DROPDOWN LIST */}

							{/* START ---------- BILLING ADDRESS: INPUT DROPDOWN LIST */}
							{showBillingAddressDrop &&
							<div className='wth3-cssMainContainer__billingInfoContainer-billingAddressWrapper'>
								<div ref={refBillAddressContainer} id='css_BillingAddressDrop' className={`wth3-inputField wth3-focusStylesContainer ${isOpenBillingAddress ? 'openDropdownStyles' : ''} ${paymentErrors.isBillingAddress ? 'has-error' : ''}`}
									onClick={(e) => toggleDropdown(e, 'css_BillingAddressDrop')}
									onKeyDown={(e) => {
										if (e.key === 'Enter' || e.key === ' ') {
											e.preventDefault();
											toggleDropdown(e, 'css_BillingAddressDrop');
										}
									}}
									onBlur={(e) => removeErrorOutline(e, 'css_BillingAddressDrop')}
									role='combobox'
									aria-expanded={isOpenBillingAddress}
									aria-controls='downdrop-list'
									aria-labelledby='css_ccBillingAddressLabel'
									tabindex={0}
								>
									<InputFieldLabel 									
										id="css_ccBillingAddressLabel" 
										label='Billing Address'
										className='billingAddressLabel'
									/>
									<div className="wth3-inputField__box">
										<span 									
											id="customerAddressNumber" 
											className='wth3-inputField__box-value'
										>{selectedOptionBillingAddress.address ? selectedOptionBillingAddress.address : defaultBillingText}</span>
									</div>

									<div className='wth3-dropdownIcons'>
										{isOpenBillingAddress ?
											(<i class="fas fa-angle-up" aria-hidden='true'></i>) 
											:
											(<i class="fas fa-angle-down" aria-hidden='true'></i>)
									}
										
									</div>
								</div>

								{isOpenBillingAddress && (
								<ul id="customerAddressList" className='wth3-cssDropdownList' ref={billingListRef} role='listbox' tabIndex={0}
									onKeyDown={handleDropdownKeyDown}
									aria-labelledby='css_ccBillingAddressLabel'
									aria-activedescendant={highlighedIndexBillAddress >= 0 ? billingAddress[highlighedIndexBillAddress].addressNumber : undefined}
								>
									{billingAddress.map((address, index, arr)=>(
									<li key={index}
									onClick={(e) => {e.preventDefault(); ccBillingAddressOnChange(address, index)}}
									role='option'
									aria-selected={selectedOptionBillingAddress.addressNumber === address.addressNumber ? true : false}
									className={`wth3-cssDropdownList__customerNumberOptionItem ${highlighedIndexBillAddress === index ? 'wth3-focusOutlineLi' : ''} ${selectedOptionBillingAddress.addressNumber === address.addressNumber ? 'selectedOptionStyles' : ''}`}
									value={address.addressNumber} 
									id={"css_addressChoice_" + address.addressNumber}>{address.address}
									</li>
									))}
								
								</ul>
								)}
							</div>
							}
							{/* END ---------- BILLING ADDRESS: INPUT DROPDOWN LIST */}

							{/* START --------- ENTER NEW ADDRESS  */}
							{showBillingAddressFields &&
							<div id="css_BillingAddressFields" class="wth3-cssMainContainer__billingInfoContainer-newAddressWrapper">
								{/* Address 1 */}
								<div class={`wth3-cssMainContainer__billingInfoContainer-newAddressWrapper-box ${paymentErrors.isAddress1 ? 'has-error' : ''}`}>
									<div className="wth3-inputField" id="css_address1Container" role='button'
										onClick={(e) => focusInput(e, 'address1')}
										onKeyDown={() => handleKeyDownInput('address1')} 
										>
										<InputFieldLabel
											id="css_paymentAddress1Label"
											label='Street Address 1'
											htmlFor='css_address1'
											className='address1Label'
											/>
										<InputFieldValue
											onBlur={(e) => removeErrorOutline(e, 'css_address1')}
											ref={(el) => (inputRefs.current['address1'] = el)}
											id="css_address1"
											placeholder=""
											value={address1InputValue}
											onChange={handleInputChange}
											maxlength="30" 
											size="30" 
											minlength="2"
											name="css_address1"
											className='address1Value'
										/>
									</div>
									<div id="css_addressHelper" class="wth3-cssHelperText">May contain special characters:  -  '  .  #</div>
								</div>
								{/* Address 2 */}
								<div class={`wth3-cssMainContainer__billingInfoContainer-newAddressWrapper-box ${paymentErrors.isAddress2 ? 'has-error' : ''}`}>
									<div className="wth3-inputField" id="css_address2Container" role='button'
										onClick={(e) => focusInput(e, 'address2')}
										onKeyDown={() => handleKeyDownInput('address2')} 
										>
										<InputFieldLabel
											id="css_paymentAddress2Label"
											label='Street Address 2 (Optional)'
											htmlFor='css_address2'
											className='address2Label'
											/>
										<InputFieldValue
											onBlur={(e) => removeErrorOutline(e, 'css_address2')}
											ref={(el) => (inputRefs.current['address2'] = el)}
											id="css_address2"
											value={address2InputValue}
											onChange={handleInputChange}
											placeholder="" 
											size="30" 
											maxlength="30" 
											minlength="2" 
											pattern="/^[ A-Za-z0-9.#'-]*$/"
											name="css_address2"
											className='address2Value'
										/>
									</div>
									<div id="css_addressHelper2" class="wth3-cssHelperText">May contain special characters:  -  '  .  #</div>
								</div>
								{/* City */}
								<div>
									<div className={`wth3-inputField ${paymentErrors.isCity ? 'has-error' : ''}`} id="css_cityContainer" role='button'
										onClick={(e) => focusInput(e, 'city')}
										onKeyDown={() => handleKeyDownInput('city')} 
										>
										<InputFieldLabel
											id="css_paymentCityLabel"
											label='City'
											htmlFor='css_city'
											className='cityLabel'
											/>
										<InputFieldValue
											onBlur={(e) => removeErrorOutline(e, 'css_city')}
											ref={(el) => (inputRefs.current['city'] = el)}
											id="css_city"
											placeholder="" 
											size="30" 
											value={cityInputValue}
											onChange={handleInputChange}
											maxlength="30" 
											minlength="2" 
											name="css_city"
											className='cityValue'
										/>
									</div>
								</div>

								<div className="wth3-cssMainContainer__billingInfoContainer-newAddressWrapper-stateZipcodeContainer">
									{/* State */}
									<div class="wth3-cssMainContainer__billingInfoContainer-newAddressWrapper-stateZipcodeContainer-states">
										<div ref={refStatesContainer} id='css_stateContainer' className={`wth3-inputField wth3-focusStylesContainer ${isOpenStates ? 'openDropdownStyles' : ''} ${paymentErrors.isState ? 'has-error' : ''}`}
											onClick={(e) => toggleDropdown(e, 'css_stateContainer')}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault();
													toggleDropdown(e, 'css_stateContainer');
												}
											}}
											onBlur={(e) => removeErrorOutline(e, 'css_stateContainer')}
											role='combobox'
											aria-expanded={isOpenStates}
											aria-controls='downdrop-list'
											aria-labelledby='css_paymentStateLabel'
											tabindex={0}
										>
											<InputFieldLabel 									
												id="css_paymentStateLabel" 
												label='State'
												className='stateLabel'
											/>
											<div className="wth3-inputField__box">
												<span 									
													id="css_paymentState" 
													className='wth3-inputField__box-value'
												>{selectedOptionStatesName === '' ? 'Choose State' : selectedOptionStatesName}</span>
											</div>

											<div className='wth3-dropdownIcons'>
												{isOpenStates ?
													(<i class="fas fa-angle-up" aria-hidden='true'></i>) 
													:
													(<i class="fas fa-angle-down" aria-hidden='true'></i>)
												}
											</div>
										</div>

										{isOpenStates && (
											<ul id="statesList" className='wth3-cssDropdownList' ref={statesListRef} role='listbox' tabIndex={0}
												onKeyDown={handleDropdownKeyDown}
												aria-labelledby='css_paymentStateLabel'
												aria-activedescendant={highlighedIndexStates >= 0 ? statesArray[highlighedIndexStates] : undefined}
											>
												{statesArray.map((state, index, arr) => (
													<li key={index} 
														onClick={(e) => {e.preventDefault(); updateState(state, index);}}
														tabIndex={0}
														role='option'
														aria-selected={selectedOptionStatesName === state ? true : false}
														className={`wth3-cssDropdownList__customerNumberOptionItem ${highlighedIndexStates === index ? 'wth3-focusOutlineLi' : ''} ${selectedOptionStatesName === state ? 'selectedOptionStyles' : ''}`}														value={state} 
														id={"css_state_" + state}>{state}
													</li>
												))}
											</ul>
										)}
									</div>
									{/* Zipcode */}
									<div className={`wth3-zipCodeContainer ${paymentErrors.isZip ? 'has-error' : ''}`}>
										<div className="wth3-inputField" id="css_zipContainer" role='button'
											onClick={(e) => focusInput(e, 'zipCode')}
											onKeyDown={() => handleKeyDownInput('zipCode')} 
											>
											<InputFieldLabel
												id="css_paymentZipCode"
												label='Zip Code'
												htmlFor='css_zip'
												className='zipcodeLabel'
												/>
											<InputFieldValue
												onBlur={(e) => removeErrorOutline(e, 'css_zip')}
												ref={(el) => (inputRefs.current['zipCode'] = el)}
												id="css_zip"
												value={zipInputValue}
												onChange={handleInputChange}
												placeholder="" 
												maxlength="5" 
												size="5" 
												minlength="5"
												name="css_zip"
												className="zipcodeValue"
											/>
										</div>
										<div id="css_zipHelper" class="wth3-cssHelperText">5-digit U.S. Zip Code</div>
									</div>						
								</div>
							</div>
							}
							{/* END --------- ENTER NEW ADDRESS  */}
						</div>

						{/* START --------- PAYMENT INFORMATION CONTAINER  */}
						<div id="css_ccInformationSection" className="wth3-cssMainContainer__paymentInformation">
							<div class="wth3-cssMainContainer__paymentInformation-paymentInfo">
								<span id="css_paymentInfo" class="wth3-cssMainContainer__headContainer-headDesc">Payment Information</span>
							</div>
							{/* START --------- CREDIT CARD HOLDER WRAPPER  */}
							<div className={`wth3-inputField wth3-inputCreditCard ${paymentErrors.isCcNumber ? 'has-error' : ''}`} id="css_ccNumberLine" role='button'
								onClick={(e) => focusInput(e, 'creditCardEntryField')}
								onKeyDown={() => handleKeyDownInput('creditCardEntryField')}
							>
								<div className="wth3-inputField__creditCardInfo">
									<InputFieldLabel
										id="css_ccLabel"
										label='Credit Card Number'
										htmlFor='token'
										className='ccEntryFieldLabel'
									/>
									<InputFieldValue
										onBlur={(e) => removeErrorOutline(e, 'token')}
										ref={(el) => (inputRefs.current['creditCardEntryField'] = el)}
										id="token"
										onChange={(e) => updateCreditCardTypeIcon(e)}
										name="token"
										className='ccEntryFieldValue'
									/>
								</div>
								<div class="wth3-inputField__creditCardTypes" id="css_ccIcons">
									<i class="fa fa-cc-visa wth2-creditCardIcons" id="visaIcon" aria-hidden="true"></i>
									<i class="fa fa-cc-mastercard wth2-creditCardIcons" id="mastercardIcon" aria-hidden="true"></i>
									<i class="fa fa-cc-discover wth2-creditCardIcons" id="discoverIcon" aria-hidden="true"></i>
									<i class="fa fa-cc-amex wth2-creditCardIcons" id="amexIcon" aria-hidden="true"></i>
								</div>
							</div>
							{/* END --------- CREDIT CARD HOLDER WRAPPER  */}


							{/* START --------- EXPIRATION DATE CONTAINER  */}
							<fieldset id="css_ccExprLine" class="wth3-cssMainContainer__paymentInformation-cardExpDate">
								<div className="wth3-ccExpDateContainer">
									<legend class="visuallyhidden">Expiration Date:</legend>

									{/* Exp Month */}
									<div class="wth3-cssMainContainer__paymentInformation-cardExpDate-expCard">
										<div ref={refExpMonthContainer} id='css_ccExpMonthContainer' className={`wth3-inputField wth3-focusStylesContainer ${isOpenExpMonth ? 'openDropdownStyles' : ''} ${paymentErrors.isCCExpMonth ? 'has-error' : ''}`}
											onClick={(e) => toggleDropdown(e, 'css_ccExpMonthContainer')}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault();
													toggleDropdown(e, 'css_ccExpMonthContainer');
												}
											}}
											onBlur={(e) => removeErrorOutline(e, 'css_ccExpMonthContainer')}
											role='combobox'
											aria-expanded={isOpenExpMonth}
											aria-controls='downdrop-list'
											aria-labelledby='css_paymentExpMonthLabel'
											tabindex={0}
										>
											<InputFieldLabel 									
												id="css_paymentExpMonthLabel" 
												label='Expiration Month'
												className='expMonthLabel'
											/>
											<div className="wth3-inputField__box">
												<span 									
													id="ccMonth" 
													className='wth3-inputField__box-value'
												>{selectedOptionExpMonth === '' ? 'MM' : selectedOptionExpMonth}</span>
											</div>
											<div className='wth3-dropdownIcons'>
												{isOpenExpMonth ?
													(<i class="fas fa-angle-up" aria-hidden='true'></i>) 
													:
													(<i class="fas fa-angle-down" aria-hidden='true'></i>)
												}
											</div>
										</div>

										{isOpenExpMonth && (
										<ul id="expMonthList" className='wth3-cssDropdownList' ref={expMonthListRef} role='listbox' tabIndex={0}
											onKeyDown={handleDropdownKeyDown}
											aria-labelledby='css_paymentExpMonthLabel'
											aria-activedescendant={highlighedIndexExpMonth >= 0 ? expMonthArray[highlighedIndexExpMonth] : undefined}
										>
											{expMonthArray.map((monthVal, index, arr) => (
												<li key={index} 
													onClick={(e) => {e.preventDefault(); popYear(monthVal, index);}}
													role='option'
													aria-selected={selectedOptionExpMonth === monthVal ? true : false}
													className={`wth3-cssDropdownList__customerNumberOptionItem ${highlighedIndexExpMonth === index ? 'wth3-focusOutlineLi' : ''} ${selectedOptionExpMonth === monthVal ? 'selectedOptionStyles' : ''} ${monthVal === 'MM' ? 'wth3-disableItem' : ''}`}														
													value={monthVal} 
													id={"css_expMonth_" + monthVal}>{monthVal}
												</li>
											))}
										</ul>
										)}
									</div>

									{/* Exp Year */}
									<div class="wth3-cssMainContainer__paymentInformation-cardExpDate-expCard">
										<div ref={refExpYearContainer} id='css_ccExpYearContainer' className={`wth3-inputField wth3-focusStylesContainer ${isOpenExpYear ? 'openDropdownStyles' : ''} ${paymentErrors.isCCExpYear ? 'has-error' : ''}`}
											onClick={(e) => toggleDropdown(e, 'css_ccExpYearContainer')}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault();
													toggleDropdown(e, 'css_ccExpYearContainer');
												}
											}}
											role='combobox'
											aria-expanded={isOpenExpYear}
											aria-controls='downdrop-list'
											aria-labelledby='css_paymentExpYearLabel'
											tabindex={0}
										>
											<InputFieldLabel 									
												id="css_paymentExpYearLabel" 
												label='Expiration Year'
												className='expYearLabel'
											/>
											<div className="wth3-inputField__box">
												<span 									
													id="ccYear" 
													placeholder='YY'
													className='wth3-inputField__box-value'
												>{selectedOptionExpYear === '' ? 'YYYY' : selectedOptionExpYear}</span>
											</div>

											<div className='wth3-dropdownIcons'>
												{isOpenExpYear ?
													(<i class="fas fa-angle-up" aria-hidden='true'></i>) 
													:
													(<i class="fas fa-angle-down" aria-hidden='true'></i>)
												}
											</div>
										</div>

										{isOpenExpYear && (
										<ul id="expYearList" className='wth3-cssDropdownList' ref={expYearListRef} role='listbox' tabIndex={0}
											onKeyDown={handleDropdownKeyDown}
											aria-labelledby='css_paymentExpYearLabel'
											aria-activedescendant={highlighedIndexExpYear >= 0 ? expYearArray[highlighedIndexExpYear] : undefined}
										>
											{expYearArray.map((yearVal, index, arr) => (
												<li key={index} 
													onClick={(e) => {e.preventDefault(); updateYear(yearVal, index);}}
													role='option'
													aria-selected={selectedOptionExpYear === yearVal ? true : false}
													className={`wth3-cssDropdownList__customerNumberOptionItem ${highlighedIndexExpYear === index ? 'wth3-focusOutlineLi' : ''} ${selectedOptionExpYear === yearVal ? 'selectedOptionStyles' : ''} ${yearVal === 'YYYY' ? 'wth3-disableItem' : ''}`}														
													value={yearVal === 'YYYY' ? '' : yearVal} 
													id={"css_expYear_" + yearVal}>{yearVal}
												</li>
											))}
										</ul>
										)}
									</div>
								</div>
								{/* START --------- CVV CONTAINER  */}
								<div className={`wth3-cvvContainer ${paymentErrors.isCvv ? 'has-error' : ''}`}>
									<div className="wth3-inputField" id="css_ccCVVLine" role='button'
										onClick={(e) => focusInput(e, 'creditCardCvvField')}
										onKeyDown={() => handleKeyDownInput('creditCardCvvField')} >
										<InputFieldLabel
											id="css_cccvvLabel"
											label='Security Code (CVV)'
											htmlFor='css_cccvv'
											className='ccCvvFieldLabel'
										/>
										<InputFieldValue
											ref={(el) => (inputRefs.current['creditCardCvvField'] = el)}
											id="css_cccvv"
											maxlength="4"
											onChange={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')}
											onBlur={(e) => {onChangeCVVField(e); removeErrorOutline(e, 'css_cccvv');}}
											name="css_cccvv"
											className='ccCvvFieldValue'

										/>
									</div>
									<div id="cvv_helper" class="wth3-cssHelperText">
										Enter the 3 digit code on the back of your
										card (Visa, Mastercard, Discover&#174;) or 4
										digit on the front (American Express) 
									</div>
								</div>
								{/* END --------- CVV CONTAINER  */} 		
							</fieldset>	
							{/* END --------- EXPIRATION DATE CONTAINER  */}
						</div>
						{/* END --------- PAYMENT INFORMATION CONTAINER  */}

						
						<div class="wth3-cssMainContainer-pleaseNote" id="css_debitNote">
							<span class="wth3-cssMainContainer-pleaseNote-header">Please note:</span>If you are using a debit card or a Visa check card, please call your bank to see if you have a daily transaction limit before continuing to make a payment.
						</div>
						<input type='hidden' id="paymentAmount" name="paymentAmount" value={paymentAmount}/>
						<div id="css_amountPaidContainer" class="wth2_css_headdesc" style={{display:"none"}}>Amount that will be charged to your card: <span id="css_paymentAmountDisplay">{paymentAmount}</span></div>
						<div id="css_termsCondStatement" class="wth3-cssMainContainer-pleaseNote wth3-bySubmittingText">
							By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of this fare. I also understand that cancellation fees may apply.
							<div class="wth3-cssMainContainer-pleaseNote-viewTerms">{Tooltip2}</div>
						</div>	
					</div>
					}
					{/* START: BILLING AND PAYMENT INFORMATION  */}

					{payRemainingBalance>=25 &&
					<div id="css_submitButtonContainer" class="wth3-submitButtonContainer btn-wrapper">
						<button id="cssSubmitButton" class="primary-btn" onClick={e => {e.preventDefault(); paymentFormValidationSubmit();}}>Complete Payment</button>
					</div>
					}
				</form>
			</div>       
		</div>
		
		<SummaryChargesDesktop charges={charges} isExpanded={isExpanded} contentId={contentId} />
    </div>; 
}

export default PaymentDetails;